/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export type ActiveSessionBreakdown = {
  __typename?: 'ActiveSessionBreakdown';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ActiveSessions = {
  __typename?: 'ActiveSessions';
  breakdown: Array<ActiveSessionBreakdown>;
  total: Scalars['Int']['output'];
};

export enum AddAuthorsErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddAuthorsInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddAuthorsPayload = {
  __typename?: 'AddAuthorsPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AddCoOwnersError = {
  __typename?: 'AddCoOwnersError';
  code: AddCoOwnersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddCoOwnersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddCoOwnersInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddCoOwnersPayload = {
  __typename?: 'AddCoOwnersPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AddCopyrightOwnerError = {
  __typename?: 'AddCopyrightOwnerError';
  code: AddCopyrightOwnerErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddCopyrightOwnerErrorCode {
  InvalidInput = 'INVALID_INPUT',
  LimitExceeded = 'LIMIT_EXCEEDED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type AddCopyrightOwnerInput = {
  name: Scalars['String']['input'];
  type: CopyrightOwnerType;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddCopyrightOwnerPayload = {
  __typename?: 'AddCopyrightOwnerPayload';
  copyrightOwner?: Maybe<CopyrightOwner>;
  error?: Maybe<AddCopyrightOwnerError>;
};

export type AddReportViewersError = {
  __typename?: 'AddReportViewersError';
  code: AddReportViewersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddReportViewersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED',
  CannotInviteSelf = 'CANNOT_INVITE_SELF',
  ReportNotCompleted = 'REPORT_NOT_COMPLETED',
  ReportNotFound = 'REPORT_NOT_FOUND'
}

export type AddReportViewersInput = {
  invites: Array<InviteInput>;
  reportId: Scalars['ID']['input'];
};

export type AddReportViewersPayload = {
  __typename?: 'AddReportViewersPayload';
  error?: Maybe<AddReportViewersError>;
  report?: Maybe<Report>;
};

export type AddTeamMemberError = {
  __typename?: 'AddTeamMemberError';
  code: AddTeamMemberErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddTeamMemberErrorCode {
  AlreadyAMember = 'ALREADY_A_MEMBER',
  UserNotFound = 'USER_NOT_FOUND'
}

export type AddTeamMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<TeamPermission>>;
  role: TeamRole;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddTeamMemberPayload = {
  __typename?: 'AddTeamMemberPayload';
  error?: Maybe<AddTeamMemberError>;
  member?: Maybe<TeamMember>;
};

export enum AddViewersErrorCode {
  AlreadyInvited = 'ALREADY_INVITED'
}

export type AddViewersInput = {
  fileId: Scalars['ID']['input'];
  invites: Array<InviteInput>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddViewersPayload = {
  __typename?: 'AddViewersPayload';
  error?: Maybe<AddCoOwnersError>;
  file?: Maybe<File>;
};

export type AdjustOverdueInvoiceError = {
  __typename?: 'AdjustOverdueInvoiceError';
  code: AdjustOverdueInvoiceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AdjustOverdueInvoiceErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type AdjustOverdueInvoiceInput = {
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountDescription?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

export type AdjustOverdueInvoicePayload = {
  __typename?: 'AdjustOverdueInvoicePayload';
  error?: Maybe<AdjustOverdueInvoiceError>;
  expiredInvoiceId?: Maybe<Scalars['ID']['output']>;
  newInvoiceId?: Maybe<Scalars['ID']['output']>;
};

export type Analysis = {
  attributes: Array<Attribute>;
  feedback?: Maybe<FeedbackRating>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
};

export type ArchiveFileEdge = {
  __typename?: 'ArchiveFileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ArchiveFilesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ItemSort>;
};

export type ArchiveFilesPayload = {
  __typename?: 'ArchiveFilesPayload';
  success: Scalars['Boolean']['output'];
};

export type ArchivedFileConnection = {
  __typename?: 'ArchivedFileConnection';
  edges: Array<ArchiveFileEdge>;
  pageInfo: PageInfo;
  totalFiles: Scalars['Int']['output'];
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AudioAcceptedWork = {
  __typename?: 'AudioAcceptedWork';
  accepted: Scalars['Boolean']['output'];
  coverWitnesses: Array<AudioCoverWitness>;
  /** False means this summary omits attributable witnesses. Null means completeness is unknown. */
  coverWitnessesComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Parent File_ID, never a stem or view identifier. */
  fileId: Scalars['ID']['output'];
  matchSources: Array<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  regular: Array<AudioRegularEvidence>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AudioAnalysis = Analysis & {
  __typename?: 'AudioAnalysis';
  attributes: Array<Attribute>;
  feedback?: Maybe<FeedbackRating>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
  tracks: Array<Track>;
  transcript: TextWithTimestamp;
};

export type AudioBundle = {
  __typename?: 'AudioBundle';
  acceptedWorks: Array<AudioAcceptedWork>;
  /** True only when acceptedWorks contains the complete accepted union for the query scope. */
  acceptedWorksComplete: Scalars['Boolean']['output'];
  catalogueComplete: Scalars['Boolean']['output'];
  coverStatus: AudioMethodStatus;
  noMatch?: Maybe<Scalars['Boolean']['output']>;
  processedWindows?: Maybe<Scalars['Int']['output']>;
  regularStatus: AudioMethodStatus;
  searchedScopeComplete: Scalars['Boolean']['output'];
  sourceMtimeNs?: Maybe<Scalars['String']['output']>;
  sourceSha256?: Maybe<Scalars['String']['output']>;
  sourceSizeBytes?: Maybe<Scalars['Float']['output']>;
  totalWindows?: Maybe<Scalars['Int']['output']>;
  unprocessedWindows?: Maybe<Scalars['Int']['output']>;
};

export type AudioCoverWitness = {
  __typename?: 'AudioCoverWitness';
  admitted: Scalars['Boolean']['output'];
  gate: Scalars['Float']['output'];
  method: Scalars['String']['output'];
  registrationId: Scalars['ID']['output'];
  /** Native method score, not a percentage or confidence probability. */
  score: Scalars['Float']['output'];
  spanMs?: Maybe<Scalars['Float']['output']>;
  startMs?: Maybe<Scalars['Float']['output']>;
  topTied: Scalars['Boolean']['output'];
  viewId: Scalars['String']['output'];
  windowIndex: Scalars['Int']['output'];
};

export type AudioMatch = Match & {
  __typename?: 'AudioMatch';
  amplitudeUrl: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  end: Scalars['Float']['output'];
  file: ReportFile;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  matchingUrl: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  stem: Stem;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AudioMethodStatus = {
  __typename?: 'AudioMethodStatus';
  catalogueComplete?: Maybe<Scalars['Boolean']['output']>;
  completeCoverage?: Maybe<Scalars['Boolean']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type AudioRegularEvidence = {
  __typename?: 'AudioRegularEvidence';
  hashType: Scalars['String']['output'];
  /** The regular score scale. The value retains its original method units. */
  scoreKind: Scalars['String']['output'];
  similarityScore: Scalars['Float']['output'];
};

export type Author = EmailInvite | EntityWithRole;

export type AuthorEdge = {
  __typename?: 'AuthorEdge';
  cursor: Scalars['String']['output'];
  node: Author;
};

export type AuthorsConnection = {
  __typename?: 'AuthorsConnection';
  edges: Array<AuthorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuthorsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailablePlans = {
  __typename?: 'AvailablePlans';
  billingCycles: Array<BillingCycle>;
  plans: Array<PlanCard>;
};

export type AvailablePlansInput = {
  origin: Scalars['String']['input'];
  platform: Platform;
};

export type Bank = {
  __typename?: 'Bank';
  accountNumber: Scalars['String']['output'];
  address: BankAddress;
  confirmation: Confirmation;
  name?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  swiftBic: Scalars['String']['output'];
};

export type BankAddress = {
  __typename?: 'BankAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type BillingCycle = {
  __typename?: 'BillingCycle';
  callout?: Maybe<I18N>;
  frequency: Frequency;
  label: I18N;
};

export enum ButtonType {
  Default = 'DEFAULT',
  Primary = 'PRIMARY'
}

export type CancelSubscriptionError = {
  __typename?: 'CancelSubscriptionError';
  code: CancelSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CancelSubscriptionErrorCode {
  AlreadyCancelled = 'ALREADY_CANCELLED',
  NotFound = 'NOT_FOUND'
}

export type CancelSubscriptionInput = {
  userId: Scalars['ID']['input'];
};

export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  error?: Maybe<CancelSubscriptionError>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CategoryValue = {
  __typename?: 'CategoryValue';
  name: Scalars['String']['output'];
  type: RevenueSource;
  value: Money;
};

export type ChargeUserError = {
  __typename?: 'ChargeUserError';
  code: ChargeUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ChargeUserErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type ChargeUserInput = {
  amount: Scalars['Int']['input'];
  currency: Scalars['Currency']['input'];
  description: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ChargeUserPayload = {
  __typename?: 'ChargeUserPayload';
  error?: Maybe<ChargeUserError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
};

export type CoOwner = EmailInvite | EntityWithRole;

export type CoOwnerEdge = {
  __typename?: 'CoOwnerEdge';
  cursor: Scalars['String']['output'];
  node: CoOwner;
};

export type CoOwnersConnection = {
  __typename?: 'CoOwnersConnection';
  edges: Array<CoOwnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoOwnersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollaboratorFilter {
  Accepted = 'ACCEPTED',
  All = 'ALL'
}

export enum ComparisonPeriod {
  Custom = 'CUSTOM',
  PreviousMonth = 'PREVIOUS_MONTH',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  PreviousWeek = 'PREVIOUS_WEEK',
  PreviousYear = 'PREVIOUS_YEAR'
}

export type CompleteTipPayload = {
  __typename?: 'CompleteTipPayload';
  success: Scalars['Boolean']['output'];
};

export type ConfirmOriginBankDetailsError = {
  __typename?: 'ConfirmOriginBankDetailsError';
  code: ConfirmOriginBankDetailsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ConfirmOriginBankDetailsErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND',
  WireDetailsNotSet = 'WIRE_DETAILS_NOT_SET'
}

export type ConfirmOriginBankDetailsPayload = {
  __typename?: 'ConfirmOriginBankDetailsPayload';
  error?: Maybe<ConfirmOriginBankDetailsError>;
  origin?: Maybe<Origin>;
};

export type Confirmation = {
  __typename?: 'Confirmation';
  confirmed: Scalars['Boolean']['output'];
  confirmedBy?: Maybe<User>;
};

export type CookieConsentCategories = {
  __typename?: 'CookieConsentCategories';
  advertising: Scalars['Boolean']['output'];
  analytics: Scalars['Boolean']['output'];
  necessary: Scalars['Boolean']['output'];
};

export type CookieConsentCategoriesInput = {
  advertising: Scalars['Boolean']['input'];
  analytics: Scalars['Boolean']['input'];
};

export type CookieConsentContext = {
  __typename?: 'CookieConsentContext';
  consentType: CookieConsentType;
  gpcObserved: Scalars['Boolean']['output'];
};

export enum CookieConsentDecisionKind {
  AcceptAll = 'ACCEPT_ALL',
  Custom = 'CUSTOM',
  Gpc = 'GPC',
  RejectAll = 'REJECT_ALL'
}

export enum CookieConsentMethod {
  Choice = 'CHOICE',
  Gpc = 'GPC'
}

export enum CookieConsentType {
  OptIn = 'OPT_IN',
  OptOut = 'OPT_OUT'
}

export type Coords = {
  __typename?: 'Coords';
  page: Scalars['Int']['output'];
  x1: Scalars['Float']['output'];
  x2: Scalars['Float']['output'];
  y1: Scalars['Float']['output'];
  y2: Scalars['Float']['output'];
};

/**
 * A registered work the notification is about, with no other party involved —
 * losing access to it, or a failed upload of it.
 */
export type CopyrightNotificationDetails = {
  __typename?: 'CopyrightNotificationDetails';
  file: File;
};

export type CopyrightOwner = {
  __typename?: 'CopyrightOwner';
  avatar: Image;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  referenceId: Scalars['ID']['output'];
  type: CopyrightOwnerType;
};

export enum CopyrightOwnerType {
  Account = 'ACCOUNT',
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export enum CopyrightStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING'
}

export type CreateEnvelopeError = {
  __typename?: 'CreateEnvelopeError';
  code: CreateEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateEnvelopeErrorCode {
  ExpiryInvalid = 'EXPIRY_INVALID',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT'
}

export type CreateEnvelopeInput = {
  expiresAt?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey: Scalars['ID']['input'];
  reminders?: InputMaybe<EnvelopeRemindersInput>;
  signingMode: SigningMode;
  title: Scalars['String']['input'];
};

export type CreateEnvelopePayload = {
  __typename?: 'CreateEnvelopePayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<CreateEnvelopeError>;
};

export type CreateFeedbackInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  rating: FeedbackRating;
  referenceId: Scalars['ID']['input'];
  type: FeedbackType;
};

export type CreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  feedbackId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFolderError = {
  __typename?: 'CreateFolderError';
  code: CreateFolderErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateFolderErrorCode {
  InUse = 'IN_USE'
}

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['ID']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFolderPayload = {
  __typename?: 'CreateFolderPayload';
  error?: Maybe<CreateFolderError>;
  folder?: Maybe<Folder>;
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  origin: Scalars['String']['input'];
};

export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  note: Note;
};

export type CreateOriginError = {
  __typename?: 'CreateOriginError';
  code: CreateOriginErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateOriginErrorCode {
  AlreadyExists = 'ALREADY_EXISTS',
  CountryOrDomainTaken = 'COUNTRY_OR_DOMAIN_TAKEN',
  InvalidInput = 'INVALID_INPUT'
}

export type CreateOriginInput = {
  /** ISO 4217 currency code (USD, EUR, GHS, …) */
  currency: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Lowercase letters, numbers and dashes; the id becomes `gov:<slug>` (can't be changed) */
  slug: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 codes; users signing up from these countries join this government */
  supportedCountries?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOriginPayload = {
  __typename?: 'CreateOriginPayload';
  error?: Maybe<CreateOriginError>;
  origin?: Maybe<Origin>;
};

export type CreatePlanError = {
  __typename?: 'CreatePlanError';
  code: CreatePlanErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreatePlanErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type CreatePlanGroupError = {
  __typename?: 'CreatePlanGroupError';
  code: CreatePlanGroupErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreatePlanGroupErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type CreatePlanGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  origin: Scalars['String']['input'];
};

export type CreatePlanGroupPayload = {
  __typename?: 'CreatePlanGroupPayload';
  error?: Maybe<CreatePlanGroupError>;
  planGroup?: Maybe<PlanGroup>;
};

export type CreatePlanInput = {
  enabledPlatforms: Array<Platform>;
  group: Scalars['String']['input'];
  name: Scalars['String']['input'];
  origin: Scalars['String']['input'];
  type: PlanType;
};

export type CreatePlanPayload = {
  __typename?: 'CreatePlanPayload';
  error?: Maybe<CreatePlanError>;
  plan?: Maybe<PlanSummary>;
};

export type CreateReportError = {
  __typename?: 'CreateReportError';
  code: CreateReportErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum CreateReportErrorCode {
  ComparingFileNotFound = 'COMPARING_FILE_NOT_FOUND',
  CopyrightNotFound = 'COPYRIGHT_NOT_FOUND',
  EvidenceNotReady = 'EVIDENCE_NOT_READY',
  LimitExceeded = 'LIMIT_EXCEEDED'
}

export type CreateReportInput = {
  comparingId: Scalars['ID']['input'];
  copyrightId: Scalars['ID']['input'];
  /** Admin only (Dacr team access): create the report for this user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateReportPayload = {
  __typename?: 'CreateReportPayload';
  error?: Maybe<CreateReportError>;
  success: Scalars['Boolean']['output'];
};

export type CreateSignatureTemplateError = {
  __typename?: 'CreateSignatureTemplateError';
  code: CreateSignatureTemplateErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateSignatureTemplateErrorCode {
  AssetBlank = 'ASSET_BLANK',
  AssetInvalid = 'ASSET_INVALID',
  AssetTooLarge = 'ASSET_TOO_LARGE',
  AssetTooSmall = 'ASSET_TOO_SMALL',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  TemplateLimitReached = 'TEMPLATE_LIMIT_REACHED'
}

export type CreateSignatureTemplateInput = {
  /** The person adopted the normalized preview, not the file they supplied (section 6.4). */
  adoptedNormalizedPreview: Scalars['Boolean']['input'];
  idempotencyKey: Scalars['ID']['input'];
  kind: SignatureTemplateKind;
  label: Scalars['String']['input'];
  /** Required for TYPED, 1 to 100 characters. */
  text?: InputMaybe<Scalars['String']['input']>;
  typeface?: InputMaybe<SignatureTypeface>;
  /** Required for DRAWN and UPLOADED. It names the scratch object the upload wrote. */
  uploadId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSignatureTemplatePayload = {
  __typename?: 'CreateSignatureTemplatePayload';
  error?: Maybe<CreateSignatureTemplateError>;
  template?: Maybe<SignatureTemplate>;
};

export type CreateSignatureTemplateUploadError = {
  __typename?: 'CreateSignatureTemplateUploadError';
  code: CreateSignatureTemplateUploadErrorCode;
  message: Scalars['String']['output'];
};

export enum CreateSignatureTemplateUploadErrorCode {
  AssetInvalid = 'ASSET_INVALID',
  AssetTooLarge = 'ASSET_TOO_LARGE',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  TemplateLimitReached = 'TEMPLATE_LIMIT_REACHED'
}

export type CreateSignatureTemplateUploadInput = {
  byteLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  idempotencyKey: Scalars['ID']['input'];
};

export type CreateSignatureTemplateUploadPayload = {
  __typename?: 'CreateSignatureTemplateUploadPayload';
  error?: Maybe<CreateSignatureTemplateUploadError>;
  upload?: Maybe<SignatureUpload>;
};

export type CrossBorderDataPoint = {
  __typename?: 'CrossBorderDataPoint';
  inbound: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  outbound: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type CrossBorderOverTime = {
  __typename?: 'CrossBorderOverTime';
  inbound: CrossBorderSummary;
  outbound: CrossBorderSummary;
  previousSeries?: Maybe<Array<CrossBorderDataPoint>>;
  series: Array<CrossBorderDataPoint>;
};

export type CrossBorderOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CrossBorderSummary = {
  __typename?: 'CrossBorderSummary';
  change?: Maybe<PercentChange>;
  value: Scalars['Int']['output'];
};

export type CurrencyRevenue = {
  __typename?: 'CurrencyRevenue';
  amount: Money;
  currency: Scalars['Currency']['output'];
  name: Scalars['String']['output'];
};

export type DeactivateAccountError = {
  __typename?: 'DeactivateAccountError';
  code: DeactivateAccountErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeactivateAccountErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeactivateAccountPayload = {
  __typename?: 'DeactivateAccountPayload';
  error?: Maybe<DeactivateAccountError>;
  success: Scalars['Boolean']['output'];
};

export type DeclineEnvelopeError = {
  __typename?: 'DeclineEnvelopeError';
  code: DeclineEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum DeclineEnvelopeErrorCode {
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotOpen = 'ENVELOPE_NOT_OPEN',
  Forbidden = 'FORBIDDEN',
  /**
   * The key was already used on another envelope, which is a caller defect and not a replay.
   *
   * A replay of the same key on the same envelope is **success** and returns the recorded
   * state, per section 8.4. `SignEnvelopeErrorCode` has carried this member since it was
   * written and this enum did not, so a replayed decline answered ENVELOPE_NOT_OPEN.
   */
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  PartyAlreadySigned = 'PARTY_ALREADY_SIGNED',
  PartyAmbiguous = 'PARTY_AMBIGUOUS',
  PartyNotClaimed = 'PARTY_NOT_CLAIMED',
  PartyRemoved = 'PARTY_REMOVED',
  ReasonInvalid = 'REASON_INVALID'
}

/**
 * A live signer withholds assent, which terminates the envelope (section 8.7).
 *
 * It carries no `expectedVersion` (D10): every assent bumps the envelope version, so a signer
 * never holds a current one. Earlier assents and artifacts are preserved (section 5.2), and a
 * completed signature is never reverted (D8).
 */
export type DeclineEnvelopeInput = {
  envelopeId: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
  /**
   * Which party declines. One person may hold two parties on one envelope, as an individual
   * and as an officer (section 3.5), and each gives its own assent.
   *
   * Omit it when you hold exactly one party able to decline. Name it when you hold more than
   * one: omitting it is then `PARTY_AMBIGUOUS`, because declining the wrong row would retire a
   * signature you still owe. An id that is not one of your own parties is `FORBIDDEN`.
   */
  partyId?: InputMaybe<Scalars['ID']['input']>;
  /** 1 to 500 characters. It reaches the other parties on the `Declined` event. */
  reason: Scalars['String']['input'];
};

export type DeclineEnvelopePayload = {
  __typename?: 'DeclineEnvelopePayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<DeclineEnvelopeError>;
};

export type DeleteAccountError = {
  __typename?: 'DeleteAccountError';
  code: DeleteAccountErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteAccountErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  error?: Maybe<DeleteAccountError>;
  success: Scalars['Boolean']['output'];
};

export enum DeleteCopyrightOwnerErrorCode {
  CopyrightOwnerNotFound = 'COPYRIGHT_OWNER_NOT_FOUND'
}

export type DeleteCopyrightOwnerInput = {
  id: Scalars['ID']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteCopyrightOwnerPayload = {
  __typename?: 'DeleteCopyrightOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteFoldersError = {
  __typename?: 'DeleteFoldersError';
  code: DeleteFoldersErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteFoldersErrorCode {
  NotEmpty = 'NOT_EMPTY'
}

export type DeleteFoldersPayload = {
  __typename?: 'DeleteFoldersPayload';
  error?: Maybe<DeleteFoldersError>;
  success: Scalars['Boolean']['output'];
};

export type DeleteNoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOriginError = {
  __typename?: 'DeleteOriginError';
  code: DeleteOriginErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteOriginErrorCode {
  OriginActive = 'ORIGIN_ACTIVE',
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type DeleteOriginPayload = {
  __typename?: 'DeleteOriginPayload';
  deletedId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<DeleteOriginError>;
};

export type DeleteSignatureTemplateError = {
  __typename?: 'DeleteSignatureTemplateError';
  code: DeleteSignatureTemplateErrorCode;
  message: Scalars['String']['output'];
};

export enum DeleteSignatureTemplateErrorCode {
  Forbidden = 'FORBIDDEN',
  TemplateNotFound = 'TEMPLATE_NOT_FOUND'
}

export type DeleteSignatureTemplateInput = {
  idempotencyKey: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type DeleteSignatureTemplatePayload = {
  __typename?: 'DeleteSignatureTemplatePayload';
  error?: Maybe<DeleteSignatureTemplateError>;
  templateId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteUserError = {
  __typename?: 'DeleteUserError';
  code: DeleteUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum DeleteUserErrorCode {
  UserNotFound = 'USER_NOT_FOUND'
}

export type DeleteUserInput = {
  userId: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  error?: Maybe<DeleteUserError>;
  success: Scalars['Boolean']['output'];
};

export type DnaAudioCompositionEvidence = {
  __typename?: 'DnaAudioCompositionEvidence';
  arm: Scalars['String']['output'];
  confirmed: Scalars['Boolean']['output'];
  exactLaneMatch: Scalars['Boolean']['output'];
  modelVersion: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  policyMargin?: Maybe<Scalars['Float']['output']>;
  policyScore: Scalars['Float']['output'];
  rawScore: Scalars['Float']['output'];
  referenceStartSeconds?: Maybe<Scalars['Float']['output']>;
  rule: Scalars['String']['output'];
  supportKind: Scalars['String']['output'];
  supporting: Array<Scalars['Int']['output']>;
};

export type DnaCaptureBatchInput = {
  /** Base64 PCM16LE mono, or u32-LE JPEG length + JPEG + PCM for CAMERA. */
  data: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  sequence: Scalars['Int']['input'];
};

export type DnaCaptureInput = {
  mode: DnaCaptureMode;
  sampleRate: Scalars['Int']['input'];
  timezoneOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export enum DnaCaptureMode {
  Camera = 'CAMERA',
  Microphone = 'MICROPHONE'
}

export type DnaCaptureResult = {
  __typename?: 'DnaCaptureResult';
  captureStopped: Scalars['Boolean']['output'];
  evidenceFile?: Maybe<InfringingFile>;
  evidenceFileId: Scalars['ID']['output'];
  evidenceStatus: DnaEvidenceStatus;
  id: Scalars['ID']['output'];
  reportReady: Scalars['Boolean']['output'];
  result?: Maybe<DnaDetectionResult>;
};

export type DnaCaptureSession = {
  __typename?: 'DnaCaptureSession';
  batchSeconds: Scalars['Int']['output'];
  deadlineAt: Scalars['Timestamp']['output'];
  evidenceFileId: Scalars['ID']['output'];
  expiresAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  maxAudioSeconds: Scalars['Int']['output'];
  maxBatchBytes: Scalars['Int']['output'];
  minAudioSeconds: Scalars['Int']['output'];
  windowSeconds: Scalars['Int']['output'];
};

export type DnaCaptureStopPayload = {
  __typename?: 'DnaCaptureStopPayload';
  evidenceFileId?: Maybe<Scalars['ID']['output']>;
  evidenceStatus?: Maybe<DnaEvidenceStatus>;
  result?: Maybe<DnaDetectionResult>;
  success: Scalars['Boolean']['output'];
};

export type DnaDetectionFinding = {
  __typename?: 'DnaDetectionFinding';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  algorithm: Scalars['String']['output'];
  audioCompositionEvidence?: Maybe<DnaAudioCompositionEvidence>;
  audioCoverEvidence?: Maybe<Scalars['Json']['output']>;
  copyrightId?: Maybe<Scalars['ID']['output']>;
  fileDataId?: Maybe<Scalars['ID']['output']>;
  metadataStatus: Scalars['String']['output'];
  modality: Scalars['String']['output'];
  queryEndSeconds?: Maybe<Scalars['Float']['output']>;
  queryStartSeconds?: Maybe<Scalars['Float']['output']>;
  referenceEndSeconds?: Maybe<Scalars['Float']['output']>;
  referenceStartSeconds?: Maybe<Scalars['Float']['output']>;
  registrationId?: Maybe<Scalars['ID']['output']>;
  riskLevel: ScoreLevel;
  /** Native algorithm score. Consult scoreKind; this is not a confidence probability. */
  score?: Maybe<Scalars['Float']['output']>;
  scoreKind: Scalars['String']['output'];
  /** Algorithm similarity score, not a probability or confidence. */
  scorePercent?: Maybe<Scalars['Float']['output']>;
  strict?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validationPending: Scalars['Boolean']['output'];
};

export type DnaDetectionJobError = {
  __typename?: 'DnaDetectionJobError';
  code: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type DnaDetectionMeasurements = {
  __typename?: 'DnaDetectionMeasurements';
  cameraVisualMs?: Maybe<Scalars['Float']['output']>;
  detectorReceiveMs?: Maybe<Scalars['Float']['output']>;
  detectorRoundTripMs: Scalars['Float']['output'];
  detectorTotalMs: Scalars['Float']['output'];
  fileDataLookupMs: Scalars['Float']['output'];
  fileReadMs?: Maybe<Scalars['Float']['output']>;
  fingerprintMs: Scalars['Float']['output'];
  imageAddonMs?: Maybe<Scalars['Float']['output']>;
  registryMs?: Maybe<Scalars['Float']['output']>;
  totalMs: Scalars['Float']['output'];
  workerQueueMs: Scalars['Float']['output'];
};

export type DnaDetectionMultipartUpload = {
  __typename?: 'DnaDetectionMultipartUpload';
  expiresAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  maxBytes: Scalars['Float']['output'];
  partCount: Scalars['Int']['output'];
  partSizeBytes: Scalars['Int']['output'];
  parts: Array<DnaDetectionUploadPart>;
  sizeBytes: Scalars['Float']['output'];
};

export type DnaDetectionMultipartUploadInput = {
  filename: Scalars['String']['input'];
  sizeBytes: Scalars['Float']['input'];
};

export type DnaDetectionResult = {
  __typename?: 'DnaDetectionResult';
  algorithms: Array<Scalars['String']['output']>;
  audioBundle?: Maybe<AudioBundle>;
  audioCover?: Maybe<Scalars['Json']['output']>;
  baseFingerprintProcessed: Scalars['Boolean']['output'];
  /** Camera diagnostics; never includes unpromoted global candidate identifiers. */
  cameraVisual?: Maybe<Scalars['Json']['output']>;
  captureStopped?: Maybe<Scalars['Boolean']['output']>;
  capturedAudioSeconds?: Maybe<Scalars['Float']['output']>;
  completeCoverage: Scalars['Boolean']['output'];
  displayMetadataOmitted?: Maybe<Scalars['Boolean']['output']>;
  evidenceFile?: Maybe<InfringingFile>;
  evidenceFileId?: Maybe<Scalars['ID']['output']>;
  evidenceStatus?: Maybe<DnaEvidenceStatus>;
  findings: Array<DnaDetectionFinding>;
  fingerprintBytes: Scalars['Int']['output'];
  imageAddon?: Maybe<Scalars['Json']['output']>;
  incompleteReason?: Maybe<Scalars['String']['output']>;
  infringementMatchIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Current stored matches. overallMatchScore uses the 0 to 1 scale. */
  infringementMatches: Array<InfringementMatch>;
  measurements: DnaDetectionMeasurements;
  outcome: Scalars['String']['output'];
  processedAudioSeconds?: Maybe<Scalars['Float']['output']>;
  rejectedMatches: Scalars['Json']['output'];
  reportReady: Scalars['Boolean']['output'];
  windowSeconds?: Maybe<Scalars['Float']['output']>;
};

export type DnaDetectionUpload = {
  __typename?: 'DnaDetectionUpload';
  expiresAt: Scalars['Timestamp']['output'];
  headers: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  maxBytes: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DnaDetectionUploadInput = {
  filename: Scalars['String']['input'];
};

export type DnaDetectionUploadPart = {
  __typename?: 'DnaDetectionUploadPart';
  partNumber: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum DnaEvidenceStatus {
  Failed = 'FAILED',
  Recording = 'RECORDING',
  Saving = 'SAVING',
  Stored = 'STORED'
}

export type DnaFileDetectionJob = {
  __typename?: 'DnaFileDetectionJob';
  error?: Maybe<DnaDetectionJobError>;
  expiresAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  result?: Maybe<DnaDetectionResult>;
  status: DnaFileDetectionStatus;
  totalBytes: Scalars['Float']['output'];
  transferredBytes: Scalars['Float']['output'];
  windowsDone: Scalars['Int']['output'];
  windowsTotal: Scalars['Int']['output'];
};

export enum DnaFileDetectionStatus {
  Analyzing = 'ANALYZING',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Transferring = 'TRANSFERRING',
  Uploading = 'UPLOADING'
}

export type DnaSignDetectionUploadPartsInput = {
  id: Scalars['ID']['input'];
  partNumbers: Array<Scalars['Int']['input']>;
};

export type DocumentAsset = FileAsset & {
  __typename?: 'DocumentAsset';
  documentUrl?: Maybe<Scalars['String']['output']>;
  previewImageUrl: Scalars['String']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges: Array<UserDocumentEdge>;
  pageInfo: PageInfo;
  /**
   * Exact up to 10,000, which is the limit Elasticsearch tracks accurately. Unlike
   * `EnvelopeConnection`, the scope and the cost here are both defined: one filtered query
   * over one index.
   */
  totalCount: Scalars['Int']['output'];
};

export type DocumentUpload = {
  __typename?: 'DocumentUpload';
  documentId: Scalars['ID']['output'];
  expiresAt: Scalars['Float']['output'];
  fields: Array<UploadField>;
  url: Scalars['String']['output'];
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  page: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type EmailInvite = {
  __typename?: 'EmailInvite';
  email: Scalars['String']['output'];
};

export type EntitiesConnection = {
  __typename?: 'EntitiesConnection';
  edges: Array<EntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Entity = Organization | User;

export type EntityEdge = {
  __typename?: 'EntityEdge';
  cursor: Scalars['String']['output'];
  node: Entity;
};

export enum EntityType {
  User = 'USER'
}

export type EntityWithRole = {
  __typename?: 'EntityWithRole';
  entity: Entity;
  role: FileRole;
};

export type Envelope = {
  __typename?: 'Envelope';
  completedAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  documents: Array<EnvelopeDocument>;
  expiresAt?: Maybe<Scalars['Float']['output']>;
  fields: Array<Field>;
  /**
   * Over the documents only (PLAN.md D17). A signer must send this value back, so it is
   * exposed here.
   */
  frozenContentSha256?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The calling party's own state on this envelope, which is what an inbox filters on. Null
   * when the caller is the owner and not a party.
   */
  myPartyStatus?: Maybe<PartyStatus>;
  parties: Array<Party>;
  progress: EnvelopeProgress;
  reminders: EnvelopeReminders;
  rosterVersion: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['Float']['output']>;
  signingMode: SigningMode;
  source: EnvelopeSource;
  status: EnvelopeStatus;
  terminalPartyId?: Maybe<Scalars['ID']['output']>;
  terminalReason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** No `totalCount`: nothing defined its scope or its cost. */
export type EnvelopeConnection = {
  __typename?: 'EnvelopeConnection';
  edges: Array<EnvelopeEdge>;
  pageInfo: PageInfo;
};

export type EnvelopeDocument = {
  __typename?: 'EnvelopeDocument';
  currentSha256?: Maybe<Scalars['String']['output']>;
  /** Null, not an error, when the caller may not read this document. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  originalSha256?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  pageGeometry?: Maybe<Array<PageGeometry>>;
  revision?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type EnvelopeEdge = {
  __typename?: 'EnvelopeEdge';
  cursor: Scalars['String']['output'];
  node: Envelope;
};

export type EnvelopeProgress = {
  __typename?: 'EnvelopeProgress';
  signedCount: Scalars['Int']['output'];
  signerCount: Scalars['Int']['output'];
};

export type EnvelopeReminders = {
  __typename?: 'EnvelopeReminders';
  afterDays: Scalars['Int']['output'];
  maxCount: Scalars['Int']['output'];
};

export type EnvelopeRemindersInput = {
  afterDays: Scalars['Int']['input'];
  maxCount: Scalars['Int']['input'];
};

export type EnvelopeSource = {
  __typename?: 'EnvelopeSource';
  referenceId?: Maybe<Scalars['String']['output']>;
  service: Scalars['String']['output'];
};

export enum EnvelopeStatus {
  AdmissionFailed = 'ADMISSION_FAILED',
  Admitting = 'ADMITTING',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  FinalizationStalled = 'FINALIZATION_STALLED',
  Finalizing = 'FINALIZING',
  Sent = 'SENT',
  Voided = 'VOIDED'
}

export type EstimatePlanChange = {
  __typename?: 'EstimatePlanChange';
  fileLifetimeLine?: Maybe<PlanChangeFileLine>;
  outstandingLine?: Maybe<PlanChangeOutstandingLine>;
  subscriptionLine: PlanChangeSubscriptionLine;
  subtotal: Money;
  total: Money;
  totalTax: Money;
};

export type EstimatePlanChangeInput = {
  productId: Scalars['ID']['input'];
};

export type EstimateRegistrationCost = {
  __typename?: 'EstimateRegistrationCost';
  breakdown: Array<RegistrationCost>;
  total: Money;
};

export type EstimateRegistrationCostInput = {
  origins: Array<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
};

export type Exchange = {
  __typename?: 'Exchange';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  renderedPrice: Scalars['String']['output'];
};

export type ExchangeInput = {
  amount: Scalars['Float']['input'];
  fromCurrency: Scalars['String']['input'];
  toCurrency: Scalars['String']['input'];
};

export type ExtendSubscriptionError = {
  __typename?: 'ExtendSubscriptionError';
  code: ExtendSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ExtendSubscriptionErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type ExtendSubscriptionInput = {
  months: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type ExtendSubscriptionPayload = {
  __typename?: 'ExtendSubscriptionPayload';
  error?: Maybe<ExtendSubscriptionError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  enabled: Array<Scalars['String']['output']>;
};

export enum FeedbackRating {
  Down = 'DOWN',
  Up = 'UP'
}

export enum FeedbackType {
  Analysis = 'ANALYSIS',
  Report = 'REPORT'
}

export type Field = {
  __typename?: 'Field';
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  page: Scalars['Int']['output'];
  partyId: Scalars['ID']['output'];
  rect: FieldRect;
  required: Scalars['Boolean']['output'];
  type: FieldType;
};

/**
 * Fractions of the page box, origin at the TOP-LEFT. Every value is in [0, 1]. A client never
 * sends CSS pixels and never applies the flip (PLAN.md section 10.1).
 */
export type FieldRect = {
  __typename?: 'FieldRect';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type FieldRectInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum FieldType {
  Date = 'DATE',
  Initials = 'INITIALS',
  Name = 'NAME',
  Signature = 'SIGNATURE'
}

export type File = {
  __typename?: 'File';
  analysis?: Maybe<Analysis>;
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  asset?: Maybe<FileAsset>;
  authors: AuthorsConnection;
  coOwners: CoOwnersConnection;
  copyright: FileCopyright;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: FileMetadata;
  name: Scalars['String']['output'];
  notifications: Array<Maybe<Notification>>;
  owner: CopyrightOwner;
  permissions: Array<FilePermission>;
  registrant: User;
  role: FileRole;
  settings: FileSettings;
  type: FileType;
  viewers: ViewersConnection;
};


export type FileAuthorsArgs = {
  input: AuthorsInput;
};


export type FileCoOwnersArgs = {
  input: CoOwnersInput;
};


export type FileViewersArgs = {
  input: ViewersInput;
};

export type FileAsset = {
  previewImageUrl: Scalars['String']['output'];
};

export enum FileCategory {
  Audio = 'AUDIO',
  Code = 'CODE',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Video = 'VIDEO'
}

export type FileCategoryCount = {
  __typename?: 'FileCategoryCount';
  category: FileCategory;
  count: Scalars['Int']['output'];
};

export type FileCopyright = {
  __typename?: 'FileCopyright';
  id?: Maybe<Scalars['ID']['output']>;
  registrations: Array<FileRegistration>;
  status: CopyrightStatus;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  originalFilename: Scalars['String']['output'];
  size: Scalars['String']['output'];
};

export type FileMetadataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
  size: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FilePermission {
  Archive = 'ARCHIVE',
  Download = 'DOWNLOAD',
  Edit = 'EDIT',
  Invite = 'INVITE',
  Privacy = 'PRIVACY',
  View = 'VIEW'
}

export enum FilePrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type FileRegistration = {
  __typename?: 'FileRegistration';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  origin: Origin;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export enum FileRole {
  Author = 'AUTHOR',
  CoOwner = 'CO_OWNER',
  Invited = 'INVITED',
  Owner = 'OWNER',
  Public = 'PUBLIC',
  Viewer = 'VIEWER'
}

export type FileSettings = {
  __typename?: 'FileSettings';
  isPrivate: Scalars['Boolean']['output'];
};

export type FileSort = {
  direction: SortDirection;
  field: FileSortField;
};

export enum FileSortField {
  ArchivedAt = 'ARCHIVED_AT',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum FileType {
  AdobeAfterEffects = 'ADOBE_AFTER_EFFECTS',
  AdobeAudition = 'ADOBE_AUDITION',
  AdobeIllustrator = 'ADOBE_ILLUSTRATOR',
  AdobeIndesign = 'ADOBE_INDESIGN',
  AdobePhotoshop = 'ADOBE_PHOTOSHOP',
  AdobePremierPro = 'ADOBE_PREMIER_PRO',
  Audio = 'AUDIO',
  AutodeskAutocad = 'AUTODESK_AUTOCAD',
  AutodeskFusion = 'AUTODESK_FUSION',
  AutodeskMaya = 'AUTODESK_MAYA',
  Cinema_4D = 'CINEMA_4D',
  Code = 'CODE',
  DavinciResolve = 'DAVINCI_RESOLVE',
  Generic = 'GENERIC',
  Image = 'IMAGE',
  MsAccess = 'MS_ACCESS',
  MsExcel = 'MS_EXCEL',
  MsPowerPoint = 'MS_POWER_POINT',
  MsPublisher = 'MS_PUBLISHER',
  MsWord = 'MS_WORD',
  Pdf = 'PDF',
  Table = 'TABLE',
  Text = 'TEXT',
  ThreeD = 'THREE_D',
  Vector = 'VECTOR',
  Video = 'VIDEO',
  Zip = 'ZIP'
}

export type FilesByCategoryInput = {
  endDate: Scalars['Date']['input'];
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
};

export type FilesComparison = {
  __typename?: 'FilesComparison';
  change: PercentChange;
  total: Scalars['Int']['output'];
};

export type FilesConnection = {
  __typename?: 'FilesConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalStorage: Scalars['String']['output'];
};

export type FilesDataPoint = {
  __typename?: 'FilesDataPoint';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type FilesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<FileSort>;
};

export type FilesOverTime = {
  __typename?: 'FilesOverTime';
  comparison?: Maybe<FilesComparison>;
  previousSeries?: Maybe<Array<FilesDataPoint>>;
  series: Array<FilesDataPoint>;
  total: Scalars['Int']['output'];
};

export type FilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  items: ItemsConnection;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  totalFiles: Scalars['Int']['output'];
};


export type FolderItemsArgs = {
  input: FolderItemsInput;
};

export type FolderItemsFilterInput = {
  type?: InputMaybe<ItemType>;
};

export type FolderItemsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<FolderItemsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ItemSort>;
};

export enum Frequency {
  Day = 'DAY',
  Month = 'MONTH',
  OneTime = 'ONE_TIME',
  Year = 'YEAR'
}

export type GenerateInvoicePayload = {
  __typename?: 'GenerateInvoicePayload';
  url: Scalars['String']['output'];
};

export type GenericAnalysis = Analysis & {
  __typename?: 'GenericAnalysis';
  attributes: Array<Attribute>;
  feedback?: Maybe<FeedbackRating>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
};

export type GetAvatarUploadUrlInput = {
  fileName: Scalars['String']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAvatarUploadUrlPayload = {
  __typename?: 'GetAvatarUploadUrlPayload';
  headers?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GetOriginAssetUploadUrlInput = {
  assetKey: OriginAssetKey;
  fileName: Scalars['String']['input'];
  originId: Scalars['ID']['input'];
};

export type GetOriginAssetUploadUrlPayload = {
  __typename?: 'GetOriginAssetUploadUrlPayload';
  headers?: Maybe<Scalars['Json']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GiveFreeFilesError = {
  __typename?: 'GiveFreeFilesError';
  code: GiveFreeFilesErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum GiveFreeFilesErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type GiveFreeFilesInput = {
  count: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type GiveFreeFilesPayload = {
  __typename?: 'GiveFreeFilesPayload';
  error?: Maybe<GiveFreeFilesError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GovLeaderboardEntry = {
  __typename?: 'GovLeaderboardEntry';
  amount: Money;
  origin: Origin;
};

export type GovLeaderboardInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  first: Scalars['Int']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  taxType: RevenueSource;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type GovTaxOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type I18N = {
  __typename?: 'I18N';
  key: Scalars['String']['output'];
};

export type IapPaymentMethod = {
  __typename?: 'IAPPaymentMethod';
  provider: Platform;
};

export enum IdentityVerificationType {
  Document = 'DOCUMENT',
  IdNumber = 'ID_NUMBER'
}

export type Image = {
  __typename?: 'Image';
  url: Scalars['String']['output'];
};

export type ImageAsset = FileAsset & {
  __typename?: 'ImageAsset';
  previewImageUrl: Scalars['String']['output'];
};

export type ImageMatch = Match & {
  __typename?: 'ImageMatch';
  coords?: Maybe<Array<Scalars['String']['output']>>;
  file: ReportFile;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Infringement = {
  __typename?: 'Infringement';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  audioBundle?: Maybe<AudioBundle>;
  audioCoverEvidence?: Maybe<Scalars['Json']['output']>;
  copyrights: Array<File>;
  id: Scalars['ID']['output'];
  infringingFile: InfringingFile;
  label: InfringementLabel;
  matches?: Maybe<MatchSummary>;
  /** The user the match belongs to */
  owner: User;
  report?: Maybe<Report>;
  /** Processing state remains available before a complete report form exists. */
  reportStatus?: Maybe<ReportStatus>;
  timestamp: Scalars['Timestamp']['output'];
};

export type InfringementConnection = {
  __typename?: 'InfringementConnection';
  edges: Array<InfringementEdge>;
  pageInfo: PageInfo;
  totalFlags: Scalars['Int']['output'];
  totalReports: Scalars['Int']['output'];
};

export type InfringementEdge = {
  __typename?: 'InfringementEdge';
  cursor: Scalars['String']['output'];
  node: Infringement;
};

export enum InfringementLabel {
  Flag = 'FLAG',
  Report = 'REPORT'
}

export enum InfringementLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type InfringementMatch = {
  __typename?: 'InfringementMatch';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  audioBundle?: Maybe<Scalars['Json']['output']>;
  audioCoverEvidence?: Maybe<Scalars['Json']['output']>;
  copyrightId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  detections?: Maybe<Array<Scalars['Json']['output']>>;
  evidence?: Maybe<Scalars['Json']['output']>;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  infringingCopyrightId?: Maybe<Scalars['ID']['output']>;
  infringingFileId: Scalars['ID']['output'];
  infringingUserId: Scalars['ID']['output'];
  listed: Scalars['Boolean']['output'];
  matchScores: InfringementMatchScores;
  overallMatchScore?: Maybe<Scalars['Float']['output']>;
  reportId?: Maybe<Scalars['ID']['output']>;
  reportStatus?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<ScoreLevel>;
  sourceJobCreatedAt?: Maybe<Scalars['Timestamp']['output']>;
  sourceJobId?: Maybe<Scalars['ID']['output']>;
  timestamp: Scalars['Timestamp']['output'];
  totalMatchScores?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  userId: Scalars['ID']['output'];
};

export type InfringementMatchScores = {
  __typename?: 'InfringementMatchScores';
  audio: Array<Scalars['Float']['output']>;
  text: Array<Scalars['Float']['output']>;
  visual: Array<Scalars['Float']['output']>;
};

/** A potential infringement found between the recipient's work and a third party's. */
export type InfringementNotificationDetails = {
  __typename?: 'InfringementNotificationDetails';
  /** The third-party work that was flagged. Null when it is not a Dacr registration. */
  flaggedFile?: Maybe<File>;
  level: InfringementLevel;
  matchId: Scalars['ID']['output'];
  /** The recipient's own registered work. */
  registeredFile: File;
};

export enum InfringementSortField {
  Timestamp = 'TIMESTAMP'
}

export type InfringementsFilterBy = {
  group?: InputMaybe<InfringementsGroupFilterBy>;
  type?: InputMaybe<InfringementLabel>;
};

export type InfringementsGroupFilterBy = {
  id: Scalars['ID']['input'];
  timestamp: Scalars['Timestamp']['input'];
};

export type InfringementsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Admin only (Dacr team access): every user's matches */
  allUsers?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<InfringementsFilterBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InfringementsSort>;
  /** One row per match instead of grouping a work's matches across registrations */
  ungrouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Admin only (Dacr team access): another user's matches */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type InfringementsSort = {
  direction: SortDirection;
  field: InfringementSortField;
};

export type InfringingCopyrightOwner = {
  __typename?: 'InfringingCopyrightOwner';
  avatar: Image;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  referenceId: Scalars['ID']['output'];
  type: InfringingCopyrightOwnerType;
};

export enum InfringingCopyrightOwnerType {
  Account = 'ACCOUNT',
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export enum InfringingCopyrightStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING'
}

export type InfringingFile = {
  __typename?: 'InfringingFile';
  asset: FileAsset;
  attributes: Array<Attribute>;
  copyrightId?: Maybe<Scalars['ID']['output']>;
  /** Current copyright data. Live lookups run only when this field is selected. */
  currentCopyright?: Maybe<InfringingFileCurrentCopyright>;
  id: Scalars['ID']['output'];
  /** Latest indexed metadata snapshot. It is not an immutable detection-time record. */
  metadata?: Maybe<InfringingFileMetadata>;
  name: Scalars['String']['output'];
  type: FileType;
};

export type InfringingFileCurrentCopyright = {
  __typename?: 'InfringingFileCurrentCopyright';
  id: Scalars['ID']['output'];
  owner?: Maybe<InfringingCopyrightOwner>;
  recognizedOrigins: Array<InfringingFileRecognizedOrigin>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  status: InfringingCopyrightStatus;
};

export type InfringingFileMetadata = {
  __typename?: 'InfringingFileMetadata';
  captureType?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<InfringingCopyrightOwner>;
  recognizedOrigins: Array<InfringingFileRecognizedOrigin>;
  recordedAt?: Maybe<Scalars['Timestamp']['output']>;
  sourceLabel: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type InfringingFileRecognizedOrigin = {
  __typename?: 'InfringingFileRecognizedOrigin';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  origin: Origin;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type IntentText = {
  __typename?: 'IntentText';
  locale: Scalars['String']['output'];
  text: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type InviteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type: InviteType;
};

/** An invite to collaborate on a registered work. */
export type InviteNotificationDetails = {
  __typename?: 'InviteNotificationDetails';
  file: File;
  /** The person who sent the invite. */
  from: User;
  inviteId: Scalars['ID']['output'];
  status: InviteStatus;
  /** The person the invite was sent to. Null while it is still addressed to an email with no account. */
  to?: Maybe<User>;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export enum InviteType {
  Email = 'EMAIL',
  Org = 'ORG',
  User = 'USER'
}

export type InvitedEmail = {
  __typename?: 'InvitedEmail';
  email: Scalars['String']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  date?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  periodEnd: Scalars['Timestamp']['output'];
  periodStart: Scalars['Timestamp']['output'];
  price: Pricing;
  status: InvoiceStatus;
  url?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export enum InvoiceStatus {
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Refunded = 'REFUNDED'
}

export type InvoicesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type Item = File | Folder;

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: Item;
};

export enum ItemSort {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export enum ItemType {
  File = 'FILE',
  Folder = 'FOLDER'
}

export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
  totalFiles: Scalars['Int']['output'];
};

export type Logo = {
  __typename?: 'Logo';
  black: Image;
  white: Image;
};

export type MarkAllNotificationsAsReadPayload = {
  __typename?: 'MarkAllNotificationsAsReadPayload';
  success: Scalars['Boolean']['output'];
};

export type MarkNotificationsAsReadInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  success: Scalars['Boolean']['output'];
};

export type Marker = {
  __typename?: 'Marker';
  color: Scalars['String']['output'];
  hash?: Maybe<Scalars['ID']['output']>;
  shine: Scalars['Boolean']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type Match = {
  file: ReportFile;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MatchCategory = {
  __typename?: 'MatchCategory';
  breakdown: MatchCategoryBreakdownConnection;
  summary?: Maybe<MatchCategorySummary>;
  total: Scalars['Int']['output'];
  type: MatchCategoryType;
};


export type MatchCategoryBreakdownArgs = {
  input?: InputMaybe<MatchCategoryBreakdownInput>;
};

export type MatchCategoryBreakdown = {
  __typename?: 'MatchCategoryBreakdown';
  copyright: Match;
  infringingFile: Match;
};

export type MatchCategoryBreakdownConnection = {
  __typename?: 'MatchCategoryBreakdownConnection';
  edges: Array<MatchCategoryBreakdownEdge>;
  pageInfo: PageInfo;
};

export type MatchCategoryBreakdownEdge = {
  __typename?: 'MatchCategoryBreakdownEdge';
  cursor: Scalars['String']['output'];
  node: MatchCategoryBreakdown;
};

export type MatchCategoryBreakdownInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MatchCategorySummary = {
  __typename?: 'MatchCategorySummary';
  copyright: Scalars['String']['output'];
  infringingFile: Scalars['String']['output'];
};

export enum MatchCategoryType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Text = 'TEXT',
  Transcript = 'TRANSCRIPT',
  Video = 'VIDEO'
}

export type MatchSummary = {
  __typename?: 'MatchSummary';
  breakdown: Array<MatchSummaryBreakdown>;
  level: ScoreLevel;
  score?: Maybe<Scalars['Float']['output']>;
};

export type MatchSummaryBreakdown = {
  __typename?: 'MatchSummaryBreakdown';
  level: ScoreLevel;
  score: Scalars['Float']['output'];
  type: MatchCategoryType;
};

export type Matches = {
  __typename?: 'Matches';
  categories: Array<MatchCategory>;
  total: Scalars['Int']['output'];
};


export type MatchesCategoriesArgs = {
  type?: InputMaybe<MatchCategoryType>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['String']['output'];
  currency: Scalars['Currency']['output'];
  formatted: Scalars['String']['output'];
};

export type MoveItemsInput = {
  folderId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveItemsPayload = {
  __typename?: 'MoveItemsPayload';
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAuthors: AddAuthorsPayload;
  addCoOwners: AddCoOwnersPayload;
  addCopyrightOwner: AddCopyrightOwnerPayload;
  addReportViewers: AddReportViewersPayload;
  addTeamMember: AddTeamMemberPayload;
  addViewers: AddViewersPayload;
  adjustOverdueInvoice: AdjustOverdueInvoicePayload;
  archiveFiles: ArchiveFilesPayload;
  cancelDnaFileDetection: DnaFileDetectionJob;
  cancelSubscription: CancelSubscriptionPayload;
  chargeUser: ChargeUserPayload;
  completeTip: CompleteTipPayload;
  confirmOriginBankDetails: ConfirmOriginBankDetailsPayload;
  createDnaDetectionMultipartUpload: DnaDetectionMultipartUpload;
  createDnaDetectionUpload: DnaDetectionUpload;
  createEnvelope: CreateEnvelopePayload;
  createFeedback: CreateFeedbackPayload;
  createFolder: CreateFolderPayload;
  createNote: CreateNotePayload;
  /**
   * Admin only (Dacr team access): create a government. Only the essentials — assets, portal,
   * bank, plans etc. are filled in afterwards with the update mutations.
   */
  createOrigin: CreateOriginPayload;
  createPlan: CreatePlanPayload;
  createPlanGroup: CreatePlanGroupPayload;
  createReport: CreateReportPayload;
  createSignatureTemplate: CreateSignatureTemplatePayload;
  createSignatureTemplateUpload: CreateSignatureTemplateUploadPayload;
  deactivateAccount: DeactivateAccountPayload;
  declineEnvelope: DeclineEnvelopePayload;
  deleteAccount: DeleteAccountPayload;
  deleteCopyrightOwner: DeleteCopyrightOwnerPayload;
  deleteFolders: DeleteFoldersPayload;
  deleteNote: DeleteNotePayload;
  /**
   * Admin only (Dacr team access): permanently delete an inactive government and its
   * country/domain mappings. Active governments must be deactivated first.
   */
  deleteOrigin: DeleteOriginPayload;
  deleteSignatureTemplate: DeleteSignatureTemplatePayload;
  deleteUser: DeleteUserPayload;
  detectDnaCaptureBatch: DnaDetectionResult;
  detectDnaFile: DnaDetectionResult;
  /**
   * Signed, short-lived URL for a file's original source. Same rules as the legacy gateway's
   * `download` (the file must be downloadable by the user).
   */
  download: Scalars['String']['output'];
  extendSubscription: ExtendSubscriptionPayload;
  generateInvoice: GenerateInvoicePayload;
  getAvatarUploadUrl: GetAvatarUploadUrlPayload;
  getOriginAssetUploadUrl: GetOriginAssetUploadUrlPayload;
  giveFreeFiles: GiveFreeFilesPayload;
  markAllNotificationsAsRead: MarkAllNotificationsAsReadPayload;
  markNotificationsAsRead: MarkNotificationsAsReadPayload;
  moveItems: MoveItemsPayload;
  payBalance: PayBalancePayload;
  purchaseReportCredits: PurchaseReportCreditsPayload;
  recordCookieConsentDecision: RecordCookieConsentDecisionPayload;
  redeemReportCreditsPurchase: RedeemReportCreditsPurchasePayload;
  refundUser: RefundUserPayload;
  registerPushDevice: PushDeviceRegistration;
  removeAuthor: RemoveAuthorsPayload;
  removeCoOwner: RemoveCoOwnerPayload;
  removeFeedback: RemoveFeedbackPayload;
  removeReportViewer: RemoveReportViewerPayload;
  removeTeamMember: RemoveTeamMemberPayload;
  removeViewer: RemoveViewersPayload;
  renameFolder: RenameFolderPayload;
  requestApiAccess: SubmitFormPayload;
  requestBriefing: SubmitFormPayload;
  requestEnterpriseSales: SubmitFormPayload;
  revalidateDnaCapture: DnaCaptureResult;
  sendEnvelope: SendEnvelopePayload;
  setMatchVisibility: SetMatchVisibilityPayload;
  setRecognizedOrigins: SetRecognizedOriginsPayload;
  signDnaDetectionUploadParts: Array<DnaDetectionUploadPart>;
  signEnvelope: SignEnvelopePayload;
  startDnaCapture: DnaCaptureSession;
  startDnaFileDetection: DnaFileDetectionJob;
  stopDnaCapture: DnaCaptureStopPayload;
  subscribe: SubscribePayload;
  unregisterPushDevice: Scalars['Boolean']['output'];
  updateCopyrightOwner: UpdateCopyrightOwnerPayload;
  updateEmail: UpdateEmailPayload;
  updateEnvelope: UpdateEnvelopePayload;
  updateEnvelopeRoster: UpdateEnvelopeRosterPayload;
  updateFileSettings: UpdateFileSettingsPayload;
  updateNote: UpdateNotePayload;
  updateOrigin: UpdateOriginPayload;
  updateOriginBank: UpdateOriginBankPayload;
  updateOriginPortal: UpdateOriginPortalPayload;
  /**
   * Admin only (Dacr team access). Inactive governments are drafts: hidden from every client but
   * admin, and they don't take signups from their countries/domains.
   */
  updateOriginStatus: UpdateOriginStatusPayload;
  updatePaymentMethod: UpdatePaymentMethodPayload;
  updatePlan: UpdatePlanPayload;
  updateProfile: UpdateProfilePayload;
  updateReportSettings: UpdateReportSettingsPayload;
  updateSettings: UpdateSettingsPayload;
  updateSubscription: UpdateSubscriptionPayload;
  updateTeamMember: UpdateTeamMemberPayload;
  /** Admin only: activate or deactivate another user's account */
  updateUserStatus: UpdateUserStatusPayload;
  updateViewerPermissions: UpdateViewerPermissionsPayload;
  upload: UploadPayload;
  uploadInfringingFile: UploadInfringingFilePayload;
  verifyIdentity: VerifyIdentityPayload;
  voidEnvelope: VoidEnvelopePayload;
  voidInvoice: VoidInvoicePayload;
};


export type MutationAddAuthorsArgs = {
  input: AddAuthorsInput;
};


export type MutationAddCoOwnersArgs = {
  input: AddCoOwnersInput;
};


export type MutationAddCopyrightOwnerArgs = {
  input: AddCopyrightOwnerInput;
};


export type MutationAddReportViewersArgs = {
  input: AddReportViewersInput;
};


export type MutationAddTeamMemberArgs = {
  input: AddTeamMemberInput;
};


export type MutationAddViewersArgs = {
  input: AddViewersInput;
};


export type MutationAdjustOverdueInvoiceArgs = {
  input: AdjustOverdueInvoiceInput;
};


export type MutationArchiveFilesArgs = {
  ids: Array<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCancelDnaFileDetectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChargeUserArgs = {
  input: ChargeUserInput;
};


export type MutationCompleteTipArgs = {
  name: TipName;
};


export type MutationConfirmOriginBankDetailsArgs = {
  originId: Scalars['ID']['input'];
};


export type MutationCreateDnaDetectionMultipartUploadArgs = {
  input: DnaDetectionMultipartUploadInput;
};


export type MutationCreateDnaDetectionUploadArgs = {
  input: DnaDetectionUploadInput;
};


export type MutationCreateEnvelopeArgs = {
  input: CreateEnvelopeInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOriginArgs = {
  input: CreateOriginInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanGroupArgs = {
  input: CreatePlanGroupInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateSignatureTemplateArgs = {
  input: CreateSignatureTemplateInput;
};


export type MutationCreateSignatureTemplateUploadArgs = {
  input: CreateSignatureTemplateUploadInput;
};


export type MutationDeclineEnvelopeArgs = {
  input: DeclineEnvelopeInput;
};


export type MutationDeleteCopyrightOwnerArgs = {
  input: DeleteCopyrightOwnerInput;
};


export type MutationDeleteFoldersArgs = {
  ids: Array<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeleteOriginArgs = {
  originId: Scalars['ID']['input'];
};


export type MutationDeleteSignatureTemplateArgs = {
  input: DeleteSignatureTemplateInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDetectDnaCaptureBatchArgs = {
  input: DnaCaptureBatchInput;
};


export type MutationDetectDnaFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadArgs = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExtendSubscriptionArgs = {
  input: ExtendSubscriptionInput;
};


export type MutationGenerateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetAvatarUploadUrlArgs = {
  input: GetAvatarUploadUrlInput;
};


export type MutationGetOriginAssetUploadUrlArgs = {
  input: GetOriginAssetUploadUrlInput;
};


export type MutationGiveFreeFilesArgs = {
  input: GiveFreeFilesInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type MutationMoveItemsArgs = {
  input: MoveItemsInput;
};


export type MutationPurchaseReportCreditsArgs = {
  input: PurchaseReportCreditsInput;
};


export type MutationRecordCookieConsentDecisionArgs = {
  input: RecordCookieConsentDecisionInput;
};


export type MutationRedeemReportCreditsPurchaseArgs = {
  input: RedeemReportCreditsPurchaseInput;
};


export type MutationRefundUserArgs = {
  input: RefundUserInput;
};


export type MutationRegisterPushDeviceArgs = {
  token: Scalars['String']['input'];
};


export type MutationRemoveAuthorArgs = {
  input: RemoveAuthorInput;
};


export type MutationRemoveCoOwnerArgs = {
  input: RemoveCoOwnerInput;
};


export type MutationRemoveFeedbackArgs = {
  input: RemoveFeedbackInput;
};


export type MutationRemoveReportViewerArgs = {
  input: RemoveReportViewerInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveViewerArgs = {
  input: RemoveViewerInput;
};


export type MutationRenameFolderArgs = {
  input: RenameFolderInput;
};


export type MutationRequestApiAccessArgs = {
  input: RequestApiAccessInput;
};


export type MutationRequestBriefingArgs = {
  input: RequestBriefingInput;
};


export type MutationRequestEnterpriseSalesArgs = {
  input: RequestEnterpriseSalesInput;
};


export type MutationRevalidateDnaCaptureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendEnvelopeArgs = {
  input: SendEnvelopeInput;
};


export type MutationSetMatchVisibilityArgs = {
  input: SetMatchVisibilityInput;
};


export type MutationSetRecognizedOriginsArgs = {
  input: SetRecognizedOriginsInput;
};


export type MutationSignDnaDetectionUploadPartsArgs = {
  input: DnaSignDetectionUploadPartsInput;
};


export type MutationSignEnvelopeArgs = {
  input: SignEnvelopeInput;
};


export type MutationStartDnaCaptureArgs = {
  input: DnaCaptureInput;
};


export type MutationStartDnaFileDetectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStopDnaCaptureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationUnregisterPushDeviceArgs = {
  registrationId: Scalars['ID']['input'];
  revocationKey: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateCopyrightOwnerArgs = {
  input: UpdateCopyrightOwnerInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEnvelopeArgs = {
  input: UpdateEnvelopeInput;
};


export type MutationUpdateEnvelopeRosterArgs = {
  input: UpdateEnvelopeRosterInput;
};


export type MutationUpdateFileSettingsArgs = {
  input: UpdateFileSettingsInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateOriginArgs = {
  input: UpdateOriginInput;
};


export type MutationUpdateOriginBankArgs = {
  input: UpdateOriginBankInput;
};


export type MutationUpdateOriginPortalArgs = {
  input: UpdateOriginPortalInput;
};


export type MutationUpdateOriginStatusArgs = {
  input: UpdateOriginStatusInput;
};


export type MutationUpdatePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateReportSettingsArgs = {
  input: UpdateReportSettingsInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
};


export type MutationUpdateViewerPermissionsArgs = {
  input: UpdateViewerPermissionsInput;
};


export type MutationUploadArgs = {
  input: UploadInput;
};


export type MutationUploadInfringingFileArgs = {
  input: UploadInfringingFileInput;
};


export type MutationVerifyIdentityArgs = {
  input: VerifyIdentityInput;
};


export type MutationVoidEnvelopeArgs = {
  input: VoidEnvelopeInput;
};


export type MutationVoidInvoiceArgs = {
  input: VoidInvoiceInput;
};

export type MyDocumentsInput = {
  /** A zero-based offset, as the previous page's `endCursor` reports it. */
  after?: InputMaybe<Scalars['String']['input']>;
  envelopeStatus?: InputMaybe<Array<EnvelopeStatus>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Empty means every state. PENDING, SIGNED and DECLINED are the useful ones. */
  partyStatus?: InputMaybe<Array<PartyStatus>>;
  /** A phrase prefix over the document title and the envelope title. */
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<MyDocumentsSort>;
};

export enum MyDocumentsSort {
  DocumentTitle = 'DOCUMENT_TITLE',
  EnvelopeTitle = 'ENVELOPE_TITLE',
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST'
}

export enum MyEnvelopeRole {
  /** What did I send. Served from GSI3, because an owner is not necessarily a party. */
  Sent = 'SENT',
  /**
   * Every envelope this caller is a party to, served from GSI1, the party inbox. Combine it
   * with `partyStatus` to get what is still to sign (PENDING), what is signed (SIGNED) or what
   * this caller rejected (DECLINED).
   */
  ToSign = 'TO_SIGN'
}

export type MyEnvelopesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filters by the state of **this caller's own party**, which is what "what have I still to
   * sign, what have I signed, what have I rejected" asks. `TO_SIGN` serves it from the GSI1
   * sort key `STATUS#<partyStatus>#...`, so it narrows the query rather than filtering a page
   * after the read. It is ignored for `SENT`, where the caller is the owner and need not be a
   * party at all.
   */
  partyStatus?: InputMaybe<PartyStatus>;
  role: MyEnvelopeRole;
  /**
   * Filters by the state of the **envelope**: DRAFT, SENT, COMPLETED and the rest. It applies
   * to both roles.
   */
  status?: InputMaybe<EnvelopeStatus>;
};

export type Note = {
  __typename?: 'Note';
  author: User;
  content: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  origin: Scalars['String']['output'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  edges: Array<NoteEdge>;
  pageInfo: PageInfo;
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type Notification = {
  __typename?: 'Notification';
  actions: Array<NotificationAction>;
  content: I18N;
  details?: Maybe<NotificationDetails>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  timestamp: Scalars['Timestamp']['output'];
  type: NotificationType;
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  buttonType: ButtonType;
  label: I18N;
  type: NotificationActionType;
};

export enum NotificationActionType {
  AcceptAuthorRequest = 'ACCEPT_AUTHOR_REQUEST',
  AcceptOwnerRequest = 'ACCEPT_OWNER_REQUEST',
  DeclineAuthorRequest = 'DECLINE_AUTHOR_REQUEST',
  DeclineOwnerRequest = 'DECLINE_OWNER_REQUEST'
}

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalUnread: Scalars['Int']['output'];
};

export type NotificationDetails = CopyrightNotificationDetails | InfringementNotificationDetails | InviteNotificationDetails | ReportNotificationDetails | UploadNotificationDetails;

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export enum NotificationType {
  AccountPaymentFailed = 'ACCOUNT_PAYMENT_FAILED',
  AccountPaymentRequiresAction = 'ACCOUNT_PAYMENT_REQUIRES_ACTION',
  AuthorInviteAccepted = 'AUTHOR_INVITE_ACCEPTED',
  AuthorInvitePending = 'AUTHOR_INVITE_PENDING',
  AuthorRemoved = 'AUTHOR_REMOVED',
  InfringementMatchFound = 'INFRINGEMENT_MATCH_FOUND',
  OwnerInviteAccepted = 'OWNER_INVITE_ACCEPTED',
  OwnerInvitePending = 'OWNER_INVITE_PENDING',
  OwnerRemoved = 'OWNER_REMOVED',
  ReportReady = 'REPORT_READY',
  UploadEmptyFile = 'UPLOAD_EMPTY_FILE',
  UploadFailed = 'UPLOAD_FAILED',
  ViewerAdded = 'VIEWER_ADDED',
  Welcome = 'WELCOME'
}

export type NotificationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  completed: Scalars['Boolean']['output'];
  nextStep?: Maybe<OnboardingStep>;
};

export type OnboardingStep = {
  __typename?: 'OnboardingStep';
  id: Scalars['ID']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  avatar: Image;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Entity;
};

export type Origin = {
  __typename?: 'Origin';
  activePlans: Scalars['Int']['output'];
  avatar: Image;
  bank?: Maybe<Bank>;
  currency: Scalars['String']['output'];
  fees: Array<OriginFee>;
  flag: Image;
  id: Scalars['ID']['output'];
  logo: Logo;
  name: Scalars['String']['output'];
  portal?: Maybe<OriginPortal>;
  registrationCost?: Maybe<RegistrationCost>;
  registrationRevenue: Money;
  status: OriginStatus;
  storageUsed: Scalars['String']['output'];
  subscriptionRevenue: Money;
  supportedDomains: Array<Scalars['String']['output']>;
  taxRevenue: Money;
  team: Array<TeamMember>;
  totalRegistrations: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  useCurrency: Scalars['Boolean']['output'];
};


export type OriginRegistrationRevenueArgs = {
  currency: Scalars['Currency']['input'];
};


export type OriginSubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};


export type OriginTaxRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export enum OriginAssetKey {
  Avatar = 'AVATAR',
  Favicon = 'FAVICON',
  Flag = 'FLAG',
  LogoBlack = 'LOGO_BLACK',
  LogoWhite = 'LOGO_WHITE',
  MainArtwork = 'MAIN_ARTWORK',
  ShareImage = 'SHARE_IMAGE'
}

export type OriginFee = {
  __typename?: 'OriginFee';
  amount?: Maybe<OriginFeeAmount>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Int']['output']>;
  status: OriginFeeStatus;
  structure: OriginFeeStructure;
  type: OriginFeeType;
};

export type OriginFeeAmount = {
  __typename?: 'OriginFeeAmount';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum OriginFeeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum OriginFeeStructure {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum OriginFeeType {
  CrossBorder = 'CROSS_BORDER',
  Custom = 'CUSTOM',
  Recognition = 'RECOGNITION',
  Registration = 'REGISTRATION'
}

export type OriginPortal = {
  __typename?: 'OriginPortal';
  buttonText?: Maybe<Scalars['String']['output']>;
  calloutLinkText?: Maybe<Scalars['String']['output']>;
  calloutLinkUrl?: Maybe<Scalars['String']['output']>;
  calloutText?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<OriginPortalFaq>>;
  favicon?: Maybe<Image>;
  mainArtwork?: Maybe<Image>;
  shareDescription?: Maybe<Scalars['String']['output']>;
  shareImage?: Maybe<Image>;
  shareTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OriginPortalFaq = {
  __typename?: 'OriginPortalFaq';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export enum OriginStatus {
  Active = 'ACTIVE',
  /** Draft — only visible to admin (Dacr team) */
  Inactive = 'INACTIVE'
}

export type PageGeometry = {
  __typename?: 'PageGeometry';
  /** CropBox when present, else MediaBox, normalized so x0 < x1 and y0 < y1. */
  box: Array<Scalars['Float']['output']>;
  rotate: Scalars['Int']['output'];
  /** The physical display scale. It never enters the coordinate transform (PLAN.md D20). */
  userUnit: Scalars['Float']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type Party = {
  __typename?: 'Party';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  partyRef?: Maybe<Scalars['String']['output']>;
  role: PartyRole;
  /** Derived from the assent. Null before the party signs. */
  signedAt?: Maybe<Scalars['Float']['output']>;
  /** Null while INVITED. */
  signerName?: Maybe<Scalars['String']['output']>;
  /** 0 when the party is not a sequential signer. */
  signingPosition: Scalars['Int']['output'];
  status: PartyStatus;
  /** Null while INVITED, because the address has no Dacr account yet. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum PartyRole {
  Signer = 'SIGNER',
  Viewer = 'VIEWER'
}

export enum PartyStatus {
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Pending = 'PENDING',
  Removed = 'REMOVED',
  Signed = 'SIGNED'
}

export type PayBalanceError = {
  __typename?: 'PayBalanceError';
  code: PayBalanceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PayBalanceErrorCode {
  InsufficientFunds = 'INSUFFICIENT_FUNDS'
}

export type PayBalancePayload = {
  __typename?: 'PayBalancePayload';
  error?: Maybe<PayBalanceError>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<CardPaymentMethod>;
  iap?: Maybe<IapPaymentMethod>;
};

export enum PaymentStatus {
  Chargeback = 'CHARGEBACK',
  Refunded = 'REFUNDED',
  Successful = 'SUCCESSFUL'
}

export type PaymentStatusBreakdown = {
  __typename?: 'PaymentStatusBreakdown';
  amount: Money;
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  status: PaymentStatus;
};

export type PaymentStatusBreakdownInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PercentChange = {
  __typename?: 'PercentChange';
  isPositive: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export enum Permission {
  Admin = 'ADMIN',
  Affiliate = 'AFFILIATE',
  CopyrightOwners = 'COPYRIGHT_OWNERS',
  Payments = 'PAYMENTS',
  Pro = 'PRO',
  Upload = 'UPLOAD'
}

export type Plan = {
  __typename?: 'Plan';
  description: I18N;
  freeUnits?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  platform: Platform;
  pricingTiers: Array<PricingTier>;
  revenueOverTime: PlanRevenueOverTime;
  status: PlanStatus;
  subscribers: Scalars['Int']['output'];
  subscribersOverTime: PlanSubscribersOverTime;
  subscriptionRevenue: Money;
  type: PlanType;
};


export type PlanRevenueOverTimeArgs = {
  input: PlanRevenueOverTimeInput;
};


export type PlanSubscribersOverTimeArgs = {
  input: PlanSubscribersOverTimeInput;
};


export type PlanSubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export type PlanCard = {
  __typename?: 'PlanCard';
  callout?: Maybe<I18N>;
  highlight: Scalars['Boolean']['output'];
  includes: Array<PlanInclude>;
  plan: Plan;
  pricing: PlanCardPricing;
  upsell?: Maybe<PlanUpsell>;
};

export type PlanCardPricing = {
  __typename?: 'PlanCardPricing';
  copyrightPrice?: Maybe<Scalars['String']['output']>;
  copyrightPriceQualifier?: Maybe<I18N>;
  subscriptionPrice: Scalars['String']['output'];
  subscriptionPriceQualifier?: Maybe<I18N>;
};

export type PlanChangeFileLine = {
  __typename?: 'PlanChangeFileLine';
  amount: Money;
  quantity: Scalars['Int']['output'];
  unitAmount: Money;
};

export type PlanChangeOutstandingLine = {
  __typename?: 'PlanChangeOutstandingLine';
  amount: Money;
  name: Scalars['String']['output'];
};

export type PlanChangeSubscriptionLine = {
  __typename?: 'PlanChangeSubscriptionLine';
  amount: Money;
  name: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
};

export type PlanEdge = {
  __typename?: 'PlanEdge';
  cursor: Scalars['String']['output'];
  node: PlanSummary;
};

export type PlanGroup = {
  __typename?: 'PlanGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  planCount: Scalars['Int']['output'];
  status: PlanGroupStatus;
};

export enum PlanGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PlanInclude = {
  __typename?: 'PlanInclude';
  description?: Maybe<I18N>;
  link?: Maybe<PlanIncludeLink>;
  separator?: Maybe<Scalars['Boolean']['output']>;
  text: I18N;
};

export type PlanIncludeLink = {
  __typename?: 'PlanIncludeLink';
  text: I18N;
  url: Scalars['String']['output'];
};

export type PlanPricing = {
  __typename?: 'PlanPricing';
  copyright?: Maybe<Pricing>;
  subscription: Pricing;
};

export type PlanRevenueDataPoint = {
  __typename?: 'PlanRevenueDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  value: Money;
};

export type PlanRevenueOverTime = {
  __typename?: 'PlanRevenueOverTime';
  series: Array<PlanRevenueDataPoint>;
  total: Money;
};

export type PlanRevenueOverTimeInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum PlanStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type PlanSubscribersOverTime = {
  __typename?: 'PlanSubscribersOverTime';
  cancelled: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  series: Array<SubscriberDataPoint>;
};

export type PlanSubscribersOverTimeInput = {
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlanSummary = {
  __typename?: 'PlanSummary';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  enabledPlatforms: Array<Platform>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  origin: Origin;
  plans: Array<PlanCard>;
  status: PlanStatus;
  subscribers: Scalars['Int']['output'];
  subscriptionRevenue: Money;
  type: PlanType;
};


export type PlanSummarySubscriptionRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export enum PlanType {
  Basic = 'BASIC',
  Bundle = 'BUNDLE',
  Lifetime = 'LIFETIME',
  Pro = 'PRO'
}

export type PlanUpsell = {
  __typename?: 'PlanUpsell';
  annualCallout?: Maybe<Scalars['String']['output']>;
  annualTitle?: Maybe<Scalars['String']['output']>;
  callout?: Maybe<Scalars['String']['output']>;
  membershipCompareAt?: Maybe<Money>;
  registrationCompareAt?: Maybe<Money>;
};

export type PlansConnection = {
  __typename?: 'PlansConnection';
  edges: Array<PlanEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type PlansInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlanStatus>;
  type?: InputMaybe<PlanType>;
};

export enum Platform {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Web = 'WEB'
}

export type PlatformDataPoint = {
  __typename?: 'PlatformDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  values: Array<PlatformValue>;
};

export type PlatformSummary = {
  __typename?: 'PlatformSummary';
  change?: Maybe<PercentChange>;
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
  total: Money;
};

export type PlatformValue = {
  __typename?: 'PlatformValue';
  label: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  value: Money;
};

export type Pricing = {
  __typename?: 'Pricing';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  frequency?: Maybe<Frequency>;
};

export type PricingTier = {
  __typename?: 'PricingTier';
  copyrights?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pricing?: Maybe<PlanPricing>;
};

export type PurchaseReportCreditsError = {
  __typename?: 'PurchaseReportCreditsError';
  code: PurchaseReportCreditsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum PurchaseReportCreditsErrorCode {
  PaymentFailed = 'PAYMENT_FAILED',
  ProductNotFound = 'PRODUCT_NOT_FOUND'
}

export type PurchaseReportCreditsInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

export type PurchaseReportCreditsPayload = {
  __typename?: 'PurchaseReportCreditsPayload';
  error?: Maybe<PurchaseReportCreditsError>;
  requiresAction?: Maybe<RequiresAction>;
};

export type PushDeviceRegistration = {
  __typename?: 'PushDeviceRegistration';
  registrationId: Scalars['ID']['output'];
  revocationKey: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeSessions: ActiveSessions;
  availablePlans: AvailablePlans;
  cookieConsentContext: CookieConsentContext;
  crossBorderOverTime: CrossBorderOverTime;
  /** The text a signer must be shown. Its `version` goes back in the assent. */
  currentIntentText: IntentText;
  dnaCaptureResult: DnaCaptureResult;
  dnaFileDetection: DnaFileDetectionJob;
  envelope?: Maybe<Envelope>;
  estimatePlanChange?: Maybe<EstimatePlanChange>;
  estimateRegistrationCost?: Maybe<EstimateRegistrationCost>;
  exchange?: Maybe<Exchange>;
  featureFlags: FeatureFlags;
  file?: Maybe<File>;
  files: FilesConnection;
  filesByCategory: Array<FileCategoryCount>;
  filesOverTime: FilesOverTime;
  folder?: Maybe<Folder>;
  folderByPath?: Maybe<Folder>;
  govLeaderboard: Array<GovLeaderboardEntry>;
  /** Tax and fee revenue collected for all government origins, by tax type */
  govTaxOverTime: RevenueOverTimeResult;
  iapAccountToken: Scalars['ID']['output'];
  infringement: Infringement;
  infringements: InfringementConnection;
  me: User;
  /**
   * Every document this caller is a party to, one row per document, served from the
   * `dacrsign_documents_latest` Elasticsearch index. Filter `partyStatus` by PENDING for
   * still to sign, SIGNED for signed and DECLINED for rejected.
   *
   * DynamoDB stays the source of truth. This answers the list question that GSI1 cannot:
   * sorting and free-text search across every envelope at once.
   */
  myDocuments: DocumentConnection;
  myEnvelopes: EnvelopeConnection;
  mySignatureTemplates: Array<SignatureTemplate>;
  openChargebackCount: Scalars['Int']['output'];
  origin?: Maybe<Origin>;
  origins: Array<Origin>;
  paymentStatusBreakdown: Array<PaymentStatusBreakdown>;
  ping: Scalars['String']['output'];
  plan?: Maybe<PlanSummary>;
  planGroups: Array<PlanGroup>;
  plans: PlansConnection;
  report?: Maybe<Report>;
  reportOgCard?: Maybe<ReportOgCard>;
  reportProducts: Array<ReportProduct>;
  reports: ReportConnection;
  /**
   * Revenue per settlement currency. Omit the dates for all-time; revenueType
   * defaults to NET.
   */
  revenueByCurrency: Array<CurrencyRevenue>;
  revenueByPlatformOverTime: RevenueByPlatformOverTime;
  revenueOverTime: RevenueOverTimeResult;
  /**
   * Users and organizations matching `query` — router port of the legacy gateway's
   * `searchEntities` (invite search on web). Excludes deleted/deactivated users and, unless
   * `showOwnEntity`, the acting user and organizations they own.
   */
  searchEntities: EntitiesConnection;
  statements: StatementsConnection;
  totalFilesOverTime: FilesOverTime;
  totalSubscriptions: Scalars['Int']['output'];
  totalUsersOverTime: UsersOverTime;
  upcomingRevenue: RevenueOverTimeResult;
  user?: Maybe<User>;
  userFolderByPath?: Maybe<Folder>;
  users: UsersConnection;
  usersOverTime: UsersOverTime;
};


export type QueryAvailablePlansArgs = {
  input: AvailablePlansInput;
};


export type QueryCrossBorderOverTimeArgs = {
  input: CrossBorderOverTimeInput;
};


export type QueryCurrentIntentTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDnaCaptureResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDnaFileDetectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnvelopeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEstimatePlanChangeArgs = {
  input: EstimatePlanChangeInput;
};


export type QueryEstimateRegistrationCostArgs = {
  input: EstimateRegistrationCostInput;
};


export type QueryExchangeArgs = {
  input: ExchangeInput;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilesArgs = {
  input: FilesInput;
};


export type QueryFilesByCategoryArgs = {
  input: FilesByCategoryInput;
};


export type QueryFilesOverTimeArgs = {
  input: FilesOverTimeInput;
};


export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFolderByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryGovLeaderboardArgs = {
  input: GovLeaderboardInput;
};


export type QueryGovTaxOverTimeArgs = {
  input: GovTaxOverTimeInput;
};


export type QueryInfringementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInfringementsArgs = {
  input?: InputMaybe<InfringementsInput>;
};


export type QueryMyDocumentsArgs = {
  input: MyDocumentsInput;
};


export type QueryMyEnvelopesArgs = {
  input: MyEnvelopesInput;
};


export type QueryOpenChargebackCountArgs = {
  origin: Scalars['ID']['input'];
};


export type QueryOriginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentStatusBreakdownArgs = {
  input: PaymentStatusBreakdownInput;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlanGroupsArgs = {
  origin: Scalars['String']['input'];
};


export type QueryPlansArgs = {
  input?: InputMaybe<PlansInput>;
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportOgCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportProductsArgs = {
  platform?: InputMaybe<Platform>;
};


export type QueryReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryRevenueByCurrencyArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  origin: Scalars['ID']['input'];
  revenueType?: InputMaybe<RevenueType>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRevenueByPlatformOverTimeArgs = {
  input: RevenueByPlatformOverTimeInput;
};


export type QueryRevenueOverTimeArgs = {
  input: RevenueOverTimeInput;
};


export type QuerySearchEntitiesArgs = {
  input: SearchEntitiesInput;
};


export type QueryStatementsArgs = {
  input: StatementsInput;
};


export type QueryTotalFilesOverTimeArgs = {
  input: TotalFilesOverTimeInput;
};


export type QueryTotalUsersOverTimeArgs = {
  input: TotalUsersOverTimeInput;
};


export type QueryUpcomingRevenueArgs = {
  input: UpcomingRevenueInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFolderByPathArgs = {
  path: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  input: UsersInput;
};


export type QueryUsersOverTimeArgs = {
  input: UsersOverTimeInput;
};

export type RecognitionRequiresAction = {
  __typename?: 'RecognitionRequiresAction';
  clientSecret: Scalars['String']['output'];
};

export type RecordCookieConsentDecisionInput = {
  buildSha: Scalars['String']['input'];
  categories: CookieConsentCategoriesInput;
  consentId: Scalars['ID']['input'];
  decisionId: Scalars['ID']['input'];
  displayedConsentType: CookieConsentType;
  method: CookieConsentMethod;
  noticeVersion: Scalars['String']['input'];
  occurredAt: Scalars['Timestamp']['input'];
  url: Scalars['String']['input'];
};

export type RecordCookieConsentDecisionPayload = {
  __typename?: 'RecordCookieConsentDecisionPayload';
  categories: CookieConsentCategories;
  consentTypeMismatch: Scalars['Boolean']['output'];
  decisionId: Scalars['ID']['output'];
  decisionKind: CookieConsentDecisionKind;
  gpcObserved: Scalars['Boolean']['output'];
  observedConsentType: CookieConsentType;
  recordedAt: Scalars['Timestamp']['output'];
};

export type RedeemReportCreditsPurchaseError = {
  __typename?: 'RedeemReportCreditsPurchaseError';
  code: RedeemReportCreditsPurchaseErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RedeemReportCreditsPurchaseErrorCode {
  /** Already redeemed by a different user. Final. */
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  /** Not a valid purchased consumable for this app, product and user, or refunded/revoked. Final. */
  InvalidPurchase = 'INVALID_PURCHASE',
  /** The store has not completed the payment yet. Retry later. */
  Pending = 'PENDING',
  /** No active report product with that storeProductId on the platform. Retry later. */
  ProductNotFound = 'PRODUCT_NOT_FOUND'
}

export type RedeemReportCreditsPurchaseInput = {
  platform: Platform;
  /** Google: the Play purchase token. */
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  storeProductId: Scalars['String']['input'];
  /** Apple: the StoreKit transaction id. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type RedeemReportCreditsPurchasePayload = {
  __typename?: 'RedeemReportCreditsPurchasePayload';
  /** Credits this purchase granted (also on an idempotent repeat by the same user). */
  credits?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<RedeemReportCreditsPurchaseError>;
};

export type RefundUserError = {
  __typename?: 'RefundUserError';
  code: RefundUserErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RefundUserErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type RefundUserInput = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};

export type RefundUserPayload = {
  __typename?: 'RefundUserPayload';
  error?: Maybe<RefundUserError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
};

export type RegistrationCost = {
  __typename?: 'RegistrationCost';
  breakdown: Array<RegistrationCostItem>;
  description: Scalars['String']['output'];
  origin: Origin;
  total: Money;
};

export type RegistrationCostItem = {
  __typename?: 'RegistrationCostItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total: Money;
};

export type RemoveAuthorInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveAuthorsPayload = {
  __typename?: 'RemoveAuthorsPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveCoOwnerInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveCoOwnerPayload = {
  __typename?: 'RemoveCoOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveFeedbackInput = {
  referenceId: Scalars['ID']['input'];
  type: FeedbackType;
};

export type RemoveFeedbackPayload = {
  __typename?: 'RemoveFeedbackPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveReportViewerInput = {
  invite: InviteInput;
  reportId: Scalars['ID']['input'];
};

export type RemoveReportViewerPayload = {
  __typename?: 'RemoveReportViewerPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveTeamMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveTeamMemberPayload = {
  __typename?: 'RemoveTeamMemberPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveViewerInput = {
  fileId: Scalars['ID']['input'];
  invite: InviteInput;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveViewersPayload = {
  __typename?: 'RemoveViewersPayload';
  success: Scalars['Boolean']['output'];
};

export type RenameFolderError = {
  __typename?: 'RenameFolderError';
  code: RenameFolderErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RenameFolderErrorCode {
  InUse = 'IN_USE'
}

export type RenameFolderInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RenameFolderPayload = {
  __typename?: 'RenameFolderPayload';
  error?: Maybe<RenameFolderError>;
  folder?: Maybe<Folder>;
};

export type Report = {
  __typename?: 'Report';
  /** Admin only (Dacr team access): the owner's feedback with its message; null otherwise */
  adminFeedback?: Maybe<ReportFeedback>;
  audioBundle: AudioBundle;
  copyright: File;
  feedback?: Maybe<FeedbackRating>;
  id: Scalars['ID']['output'];
  infringingFile: InfringingFile;
  level: ScoreLevel;
  matches: Matches;
  /** The user the report belongs to (who created it) */
  owner: User;
  pdf: ReportPdf;
  role: ReportRole;
  score: Scalars['Float']['output'];
  settings: ReportSettings;
  status: ReportStatus;
  summary: Scalars['String']['output'];
  timeline?: Maybe<TimelineGroup>;
  timestamp: Scalars['Timestamp']['output'];
  viewers: ReportViewersConnection;
};


export type ReportViewersArgs = {
  input: ReportViewersInput;
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  edges: Array<ReportEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type ReportEdge = {
  __typename?: 'ReportEdge';
  cursor: Scalars['String']['output'];
  node: Report;
};

export type ReportFeedback = {
  __typename?: 'ReportFeedback';
  createdAt: Scalars['Timestamp']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rating: FeedbackRating;
  user: User;
};

export type ReportFile = File | InfringingFile;

export type ReportNotificationDetails = {
  __typename?: 'ReportNotificationDetails';
  registeredFile: File;
  reportId: Scalars['ID']['output'];
};

export type ReportOgAudioSummary = {
  __typename?: 'ReportOgAudioSummary';
  coverAccepted: Scalars['Boolean']['output'];
  coverState: Scalars['String']['output'];
  regularAccepted: Scalars['Boolean']['output'];
  regularState: Scalars['String']['output'];
};

export type ReportOgCard = {
  __typename?: 'ReportOgCard';
  audioSummary?: Maybe<ReportOgAudioSummary>;
  comparedFileType: FileType;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  level: ScoreLevel;
  registeredFileType: FileType;
  score: Scalars['Float']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

/**
 * Downloadable PDF of the report, baked asynchronously on completion and
 * re-baked whenever match visibility changes.
 */
export type ReportPdf = {
  __typename?: 'ReportPdf';
  status: ReportPdfStatus;
  /** Short-lived download URL. Only present when status is READY. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportPdfStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type ReportProduct = {
  __typename?: 'ReportProduct';
  callout?: Maybe<Scalars['String']['output']>;
  credits: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Pricing;
  /** The App Store / Google Play product id; null for web products. */
  storeProductId?: Maybe<Scalars['String']['output']>;
};

export enum ReportRole {
  Owner = 'OWNER',
  Public = 'PUBLIC',
  Viewer = 'VIEWER'
}

export type ReportSettings = {
  __typename?: 'ReportSettings';
  isPrivate: Scalars['Boolean']['output'];
};

export enum ReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type ReportViewer = EmailInvite | Organization | User;

export type ReportViewerEdge = {
  __typename?: 'ReportViewerEdge';
  cursor: Scalars['String']['output'];
  node: ReportViewer;
  role: ReportRole;
};

export type ReportViewersConnection = {
  __typename?: 'ReportViewersConnection';
  edges: Array<ReportViewerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReportViewersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CollaboratorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Only this user's reports */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RequestApiAccessInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  project: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type RequestBriefingInput = {
  agency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RequestEnterpriseSalesInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RequiresAction = {
  __typename?: 'RequiresAction';
  clientSecret: Scalars['String']['output'];
};

export type RevenueByPlatformOverTime = {
  __typename?: 'RevenueByPlatformOverTime';
  platforms: Array<PlatformSummary>;
  previousSeries?: Maybe<Array<PlatformDataPoint>>;
  series: Array<PlatformDataPoint>;
};

export type RevenueByPlatformOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueCategory = {
  __typename?: 'RevenueCategory';
  change?: Maybe<PercentChange>;
  name: Scalars['String']['output'];
  total: Money;
  type: RevenueSource;
};

export type RevenueCategoryTotal = {
  __typename?: 'RevenueCategoryTotal';
  amount: Money;
  type: RevenueSource;
};

export type RevenueComparison = {
  __typename?: 'RevenueComparison';
  change: PercentChange;
  total: Money;
};

export type RevenueDataPoint = {
  __typename?: 'RevenueDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  value: Money;
};

export type RevenueOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whose revenue: 'Dacr', 'gov:rio', etc. */
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  /** Scope to transactions billed through this origin (e.g., Dacr's cut from gov:rio) */
  sourceOrigin?: InputMaybe<Scalars['ID']['input']>;
  /** Filter to specific revenue sources. Omit for all. */
  sources?: InputMaybe<Array<RevenueSource>>;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueOverTimeResult = {
  __typename?: 'RevenueOverTimeResult';
  /** Time series broken down by source (for stacked area charts) */
  breakdownSeries: Array<StackedDataPoint>;
  /** Revenue broken down by source */
  categories: Array<RevenueCategory>;
  /** Comparison period (when compareTo is set) */
  comparison?: Maybe<RevenueComparison>;
  previousBreakdownSeries?: Maybe<Array<StackedDataPoint>>;
  previousSeries?: Maybe<Array<RevenueDataPoint>>;
  /** Aggregate time series */
  series: Array<RevenueDataPoint>;
  /** Period total */
  total: Money;
};

export enum RevenueSource {
  Credit = 'CREDIT',
  CrossBorder = 'CROSS_BORDER',
  Custom = 'CUSTOM',
  Recognition = 'RECOGNITION',
  Registration = 'REGISTRATION',
  Report = 'REPORT',
  Subscription = 'SUBSCRIPTION'
}

export enum RevenueType {
  Gross = 'GROSS',
  Net = 'NET'
}

export enum ScoreLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SearchEntitiesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<SearchEntityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  showOwnEntity?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchEntityType {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type SendEnvelopeError = {
  __typename?: 'SendEnvelopeError';
  code: SendEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum SendEnvelopeErrorCode {
  DocumentCountExceeded = 'DOCUMENT_COUNT_EXCEEDED',
  DocumentLocked = 'DOCUMENT_LOCKED',
  DocumentMissing = 'DOCUMENT_MISSING',
  DocumentTitleDuplicate = 'DOCUMENT_TITLE_DUPLICATE',
  DocumentTooLarge = 'DOCUMENT_TOO_LARGE',
  DocumentUnsupported = 'DOCUMENT_UNSUPPORTED',
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotOpen = 'ENVELOPE_NOT_OPEN',
  ExpiryInvalid = 'EXPIRY_INVALID',
  FieldCountExceeded = 'FIELD_COUNT_EXCEEDED',
  FieldCountPerParty = 'FIELD_COUNT_PER_PARTY',
  FieldOverlap = 'FIELD_OVERLAP',
  FieldPageOutOfRange = 'FIELD_PAGE_OUT_OF_RANGE',
  FieldRectInvalid = 'FIELD_RECT_INVALID',
  FieldReservedZone = 'FIELD_RESERVED_ZONE',
  FieldTextUnsupported = 'FIELD_TEXT_UNSUPPORTED',
  Forbidden = 'FORBIDDEN',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  NoSigner = 'NO_SIGNER',
  PartyCountExceeded = 'PARTY_COUNT_EXCEEDED',
  PartyDuplicate = 'PARTY_DUPLICATE',
  SignerWithoutField = 'SIGNER_WITHOUT_FIELD',
  SigningOrderInvalid = 'SIGNING_ORDER_INVALID',
  VersionConflict = 'VERSION_CONFLICT',
  ViewerScopeInvalid = 'VIEWER_SCOPE_INVALID'
}

export type SendEnvelopeInput = {
  envelopeId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['ID']['input'];
};

export type SendEnvelopePayload = {
  __typename?: 'SendEnvelopePayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<SendEnvelopeError>;
};

export type Session = {
  __typename?: 'Session';
  client?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  device?: Maybe<SessionDevice>;
  id: Scalars['ID']['output'];
  location?: Maybe<SessionLocation>;
};

export type SessionDevice = {
  __typename?: 'SessionDevice';
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SessionLocation = {
  __typename?: 'SessionLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type SetMatchVisibilityInput = {
  hidden: Scalars['Boolean']['input'];
  matchId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type SetMatchVisibilityPayload = {
  __typename?: 'SetMatchVisibilityPayload';
  report?: Maybe<Report>;
};

export type SetRecognizedOriginsInput = {
  fileIds: Array<Scalars['ID']['input']>;
  originIds: Array<Scalars['ID']['input']>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetRecognizedOriginsPayload = {
  __typename?: 'SetRecognizedOriginsPayload';
  failedMessage?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  requiresAction?: Maybe<RecognitionRequiresAction>;
};

export type SheetMusic = {
  __typename?: 'SheetMusic';
  preview: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * What this signer asserts one document hashes to. It must be the document's frozen original
 * (PLAN.md D11), which the envelope read exposes as `EnvelopeDocument.originalSha256`.
 */
export type SignEnvelopeDocumentDigestInput = {
  documentId: Scalars['ID']['input'];
  sha256: Scalars['String']['input'];
};

export type SignEnvelopeError = {
  __typename?: 'SignEnvelopeError';
  code: SignEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum SignEnvelopeErrorCode {
  AssentInvalid = 'ASSENT_INVALID',
  ContentChanged = 'CONTENT_CHANGED',
  DocumentDigestMismatch = 'DOCUMENT_DIGEST_MISMATCH',
  EnvelopeExpired = 'ENVELOPE_EXPIRED',
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotOpen = 'ENVELOPE_NOT_OPEN',
  FieldCoverage = 'FIELD_COVERAGE',
  FieldOverlap = 'FIELD_OVERLAP',
  FieldRectInvalid = 'FIELD_RECT_INVALID',
  FieldTextUnsupported = 'FIELD_TEXT_UNSUPPORTED',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  /**
   * The caller holds no signer party with that id on this envelope. It is also the answer for
   * an envelope that does not exist, so a caller with no standing cannot learn that it does.
   */
  NotASigner = 'NOT_A_SIGNER',
  NotYourTurn = 'NOT_YOUR_TURN',
  PartyAlreadySigned = 'PARTY_ALREADY_SIGNED',
  PartyNotClaimed = 'PARTY_NOT_CLAIMED',
  PartyRemoved = 'PARTY_REMOVED',
  RosterChanged = 'ROSTER_CHANGED',
  TemplateNotFound = 'TEMPLATE_NOT_FOUND'
}

/**
 * One filled field. The server builds the capture from the template, because section 6.4
 * requires the asset identity to be copied into the assent at the moment the field is filled
 * and never resolved again.
 */
export type SignEnvelopeFillInput = {
  fieldId: Scalars['ID']['input'];
  /**
   * Required for SIGNATURE and INITIALS. A NAME or DATE field takes none: the server composes
   * that text from the signer name snapshot and the server assent time (PLAN.md section 10.3).
   */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * One party gives its assent, PLAN.md section 8.4.
 *
 * **A party signs every field it owns across every document in one call.** Partial signing has
 * no legal meaning, so `fills` must cover every required field of the party. An unfilled
 * optional field is simply not painted.
 *
 * It carries no `expectedVersion` (D10): every assent bumps the envelope version, so a signer
 * never holds a current one. The guard that matters is `rosterVersion`, which the server reads
 * during validation and asserts in the same transaction (ROSTER_CHANGED).
 */
export type SignEnvelopeInput = {
  /**
   * The person accepted the intent text they were shown. False is ASSENT_INVALID: there is no
   * assent without it.
   */
  accepted: Scalars['Boolean']['input'];
  /**
   * Exactly the documents this caller may read, each with that document's frozen original
   * digest. A missing or an extra entry is DOCUMENT_DIGEST_MISMATCH.
   */
  documentSha256: Array<SignEnvelopeDocumentDigestInput>;
  envelopeId: Scalars['ID']['input'];
  fills: Array<SignEnvelopeFillInput>;
  /**
   * The envelope's `frozenContentSha256`, sent back so the server can prove the signer saw the
   * content it froze (CONTENT_CHANGED).
   */
  frozenContentSha256: Scalars['String']['input'];
  idempotencyKey: Scalars['ID']['input'];
  /** The version of the intent text the person was shown, from `currentIntentText`. */
  intentTextVersion: Scalars['String']['input'];
  /**
   * Which party signs. Required, because one person may hold two parties on one envelope, as an
   * individual and as an officer (section 3.5), and each gives its own assent.
   */
  partyId: Scalars['ID']['input'];
};

export type SignEnvelopePayload = {
  __typename?: 'SignEnvelopePayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<SignEnvelopeError>;
};

export enum SignatureQualityWarning {
  BackgroundDark = 'BACKGROUND_DARK',
  BackgroundUneven = 'BACKGROUND_UNEVEN',
  DenseInk = 'DENSE_INK',
  LittleTrimmed = 'LITTLE_TRIMMED',
  LowContrast = 'LOW_CONTRAST',
  SparseInk = 'SPARSE_INK',
  UnusualAspect = 'UNUSUAL_ASPECT'
}

export type SignatureTemplate = {
  __typename?: 'SignatureTemplate';
  /** Computed from width and height. It is never stored. */
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: SignatureTemplateKind;
  label: Scalars['String']['output'];
  /** The normalized PNG. The person adopts this image, not the file they supplied. */
  previewUrl?: Maybe<Scalars['String']['output']>;
  qualityWarnings: Array<SignatureQualityWarning>;
  text?: Maybe<Scalars['String']['output']>;
  typeface?: Maybe<SignatureTypeface>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum SignatureTemplateKind {
  Drawn = 'DRAWN',
  Typed = 'TYPED',
  Uploaded = 'UPLOADED'
}

export enum SignatureTypeface {
  Sans = 'SANS',
  Serif = 'SERIF'
}

/**
 * A presigned POST, because `shared/clients/s3.ts` offers a presigned POST and not a
 * presigned PUT.
 */
export type SignatureUpload = {
  __typename?: 'SignatureUpload';
  expiresAt: Scalars['Float']['output'];
  fields: Array<UploadField>;
  uploadId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum SigningMode {
  Parallel = 'PARALLEL',
  Sequential = 'SEQUENTIAL'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StackedDataPoint = {
  __typename?: 'StackedDataPoint';
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  values: Array<CategoryValue>;
};

export type Statement = {
  __typename?: 'Statement';
  amount: Money;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  origin: Origin;
  status: StatementStatus;
};

export type StatementEdge = {
  __typename?: 'StatementEdge';
  cursor: Scalars['String']['output'];
  node: Statement;
};

export enum StatementStatus {
  OnHold = 'ON_HOLD',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  UnderReview = 'UNDER_REVIEW'
}

export type StatementsConnection = {
  __typename?: 'StatementsConnection';
  edges: Array<StatementEdge>;
  pageInfo: PageInfo;
};

export type StatementsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
  /** Only statements dated within this range (inclusive). Omit for all. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Stem = {
  __typename?: 'Stem';
  name: Scalars['String']['output'];
  sheetMusic?: Maybe<SheetMusic>;
  url: Scalars['String']['output'];
};

export type Stems = {
  __typename?: 'Stems';
  amplitudeUrl: Scalars['String']['output'];
  breakdown: Array<Stem>;
};

export type StreamAsset = FileAsset & {
  __typename?: 'StreamAsset';
  previewImageUrl: Scalars['String']['output'];
  streamUrl?: Maybe<Scalars['String']['output']>;
};

export type SubmitFormPayload = {
  __typename?: 'SubmitFormPayload';
  success: Scalars['Boolean']['output'];
};

export type SubscribeInput = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};

export type SubscribePayload = {
  __typename?: 'SubscribePayload';
  failedMessage?: Maybe<Scalars['String']['output']>;
  processing?: Maybe<Scalars['Boolean']['output']>;
  requiresAction?: Maybe<RequiresAction>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type SubscriberDataPoint = {
  __typename?: 'SubscriberDataPoint';
  cancelled: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  new: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionAlert = {
  __typename?: 'SubscriptionAlert';
  content: I18N;
  type: SubscriptionAlertType;
};

export enum SubscriptionAlertType {
  Cancelled = 'CANCELLED',
  Chargeback = 'CHARGEBACK',
  Expired = 'EXPIRED',
  IncreaseLimit = 'INCREASE_LIMIT',
  Overdue = 'OVERDUE',
  RequiresAction = 'REQUIRES_ACTION',
  Upgrade = 'UPGRADE'
}

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  alert?: Maybe<SubscriptionAlert>;
  billingCycle: Frequency;
  cancelledAt?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  periodEnd: Scalars['Timestamp']['output'];
  periodStart: Scalars['Timestamp']['output'];
  plan: Plan;
  /**
   * The plan's non-free prices as web's billing page lists them (membership fee, then per-copyright
   * fee; bundles show their copyright allowance). Mirrors the legacy gateway's price items.
   */
  prices: Array<SubscriptionPrice>;
  pricing: PricingTier;
  status: SubscriptionStatus;
};

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  /** Minor units (cents). Null for bundles, which show only their allowance. */
  amount?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** e.g. "per month", "per copyright", "50 copyrights" */
  suffix: Scalars['String']['output'];
  type: SubscriptionPriceType;
};

export enum SubscriptionPriceType {
  Registration = 'REGISTRATION',
  Subscription = 'SUBSCRIPTION'
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Overdue = 'OVERDUE'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  email?: Maybe<Scalars['String']['output']>;
  permissions: Array<TeamPermission>;
  role: TeamRole;
  status: TeamMemberStatus;
  user?: Maybe<User>;
};

export enum TeamMemberStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED'
}

export enum TeamPermission {
  DashboardFinancials = 'DASHBOARD_FINANCIALS',
  DashboardRegistrations = 'DASHBOARD_REGISTRATIONS',
  DashboardUsers = 'DASHBOARD_USERS',
  FilesView = 'FILES_VIEW',
  StatementsView = 'STATEMENTS_VIEW',
  TeamManage = 'TEAM_MANAGE',
  TeamView = 'TEAM_VIEW',
  UsersFinancials = 'USERS_FINANCIALS',
  UsersView = 'USERS_VIEW'
}

export enum TeamRole {
  Administrator = 'ADMINISTRATOR',
  Analyst = 'ANALYST',
  Custom = 'CUSTOM',
  Support = 'SUPPORT'
}

export type TextMatch = Match & {
  __typename?: 'TextMatch';
  coords: Array<Coords>;
  file: ReportFile;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urls: Array<DocumentUrl>;
};

export type TextWithTimestamp = {
  __typename?: 'TextWithTimestamp';
  preview: Array<TextWithTimestampPreview>;
  url: Scalars['String']['output'];
};

export type TextWithTimestampPreview = {
  __typename?: 'TextWithTimestampPreview';
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum TimeGrouping {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Timeline = {
  __typename?: 'Timeline';
  audioUrl: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  frames?: Maybe<Array<Scalars['String']['output']>>;
  transcript?: Maybe<Array<Scalars['String']['output']>>;
};

export type TimelineGroup = {
  __typename?: 'TimelineGroup';
  copyright: Timeline;
  infringingFile: Timeline;
};

export type Timezone = {
  __typename?: 'Timezone';
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TimezoneInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Tip = {
  __typename?: 'Tip';
  name: TipName;
  status: TipStatus;
};

export enum TipName {
  FirstCopyright = 'FIRST_COPYRIGHT',
  Invite = 'INVITE',
  Welcome = 'WELCOME'
}

export enum TipStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE'
}

export type TotalFilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TotalUsersOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Track = {
  __typename?: 'Track';
  attributes: Array<Attribute>;
  duration?: Maybe<Scalars['Float']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  stems: Stems;
  summary: Scalars['String']['output'];
  transcript: TextWithTimestamp;
  url: Scalars['String']['output'];
};

export type Transcript = {
  __typename?: 'Transcript';
  highlight: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TranscriptMatch = Match & {
  __typename?: 'TranscriptMatch';
  end: Scalars['Float']['output'];
  file: ReportFile;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcript: Array<Maybe<Transcript>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpcomingBilling = {
  __typename?: 'UpcomingBilling';
  breakdown: Array<UpcomingBillingItem>;
  currency: Scalars['String']['output'];
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Minor units (cents) */
  tax?: Maybe<Scalars['Int']['output']>;
  /** Minor units (cents) */
  total: Scalars['Int']['output'];
};

export type UpcomingBillingItem = {
  __typename?: 'UpcomingBillingItem';
  /** Minor units (cents) */
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  outstanding: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
};

/** Projected renewals of active subscriptions whose current period ends in the range */
export type UpcomingRevenueInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  /** Only GROSS: projections use plan list prices, before processor fees */
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCopyrightOwnerError = {
  __typename?: 'UpdateCopyrightOwnerError';
  code: UpdateCopyrightOwnerErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateCopyrightOwnerErrorCode {
  CopyrightOwnerNotFound = 'COPYRIGHT_OWNER_NOT_FOUND',
  InvalidInput = 'INVALID_INPUT'
}

export type UpdateCopyrightOwnerInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCopyrightOwnerPayload = {
  __typename?: 'UpdateCopyrightOwnerPayload';
  copyrightOwner?: Maybe<CopyrightOwner>;
  error?: Maybe<UpdateCopyrightOwnerError>;
};

export type UpdateEmailError = {
  __typename?: 'UpdateEmailError';
  code: UpdateEmailErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateEmailErrorCode {
  EmailTaken = 'EMAIL_TAKEN',
  InvalidEmailFormat = 'INVALID_EMAIL_FORMAT'
}

export type UpdateEmailInput = {
  email: Scalars['String']['input'];
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  error?: Maybe<UpdateEmailError>;
  user?: Maybe<User>;
};

export type UpdateEnvelopeDocumentInput = {
  order: Scalars['Int']['input'];
  /** Request-local. Titles are not keys. */
  ref: Scalars['String']['input'];
  sha256?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** Present once the upload has written bytes. */
  uploadId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEnvelopeError = {
  __typename?: 'UpdateEnvelopeError';
  code: UpdateEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum UpdateEnvelopeErrorCode {
  DocumentCountExceeded = 'DOCUMENT_COUNT_EXCEEDED',
  DocumentTitleDuplicate = 'DOCUMENT_TITLE_DUPLICATE',
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotOpen = 'ENVELOPE_NOT_OPEN',
  ExpiryInvalid = 'EXPIRY_INVALID',
  FieldCountExceeded = 'FIELD_COUNT_EXCEEDED',
  FieldCountPerParty = 'FIELD_COUNT_PER_PARTY',
  FieldOverlap = 'FIELD_OVERLAP',
  FieldPageOutOfRange = 'FIELD_PAGE_OUT_OF_RANGE',
  FieldRectInvalid = 'FIELD_RECT_INVALID',
  FieldReservedZone = 'FIELD_RESERVED_ZONE',
  Forbidden = 'FORBIDDEN',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  NoSigner = 'NO_SIGNER',
  PartyCountExceeded = 'PARTY_COUNT_EXCEEDED',
  PartyDuplicate = 'PARTY_DUPLICATE',
  SignerWithoutField = 'SIGNER_WITHOUT_FIELD',
  SigningOrderInvalid = 'SIGNING_ORDER_INVALID',
  VersionConflict = 'VERSION_CONFLICT',
  ViewerScopeInvalid = 'VIEWER_SCOPE_INVALID'
}

export type UpdateEnvelopeFieldInput = {
  documentRef: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  partyRef: Scalars['String']['input'];
  rect: FieldRectInput;
  required: Scalars['Boolean']['input'];
  type: FieldType;
};

/**
 * Draft only. It replaces the whole roster on every call, which is why an invite leaves at
 * `sendEnvelope` and never at declaration (PLAN.md section 9.1).
 */
export type UpdateEnvelopeInput = {
  documents: Array<UpdateEnvelopeDocumentInput>;
  envelopeId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['Float']['input']>;
  fields: Array<UpdateEnvelopeFieldInput>;
  idempotencyKey: Scalars['ID']['input'];
  parties: Array<UpdateEnvelopePartyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnvelopePartyInput = {
  documentRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  partyRef?: InputMaybe<Scalars['String']['input']>;
  ref: Scalars['String']['input'];
  role: PartyRole;
  signingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEnvelopePayload = {
  __typename?: 'UpdateEnvelopePayload';
  documentUploads?: Maybe<Array<DocumentUpload>>;
  envelope?: Maybe<Envelope>;
  error?: Maybe<UpdateEnvelopeError>;
};

export type UpdateEnvelopeRosterError = {
  __typename?: 'UpdateEnvelopeRosterError';
  code: UpdateEnvelopeRosterErrorCode;
  message: Scalars['String']['output'];
};

export enum UpdateEnvelopeRosterErrorCode {
  DocumentCountExceeded = 'DOCUMENT_COUNT_EXCEEDED',
  DocumentMissing = 'DOCUMENT_MISSING',
  DocumentTitleDuplicate = 'DOCUMENT_TITLE_DUPLICATE',
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotOpen = 'ENVELOPE_NOT_OPEN',
  ExpiryInvalid = 'EXPIRY_INVALID',
  FieldCountExceeded = 'FIELD_COUNT_EXCEEDED',
  FieldCountPerParty = 'FIELD_COUNT_PER_PARTY',
  FieldImmutable = 'FIELD_IMMUTABLE',
  FieldOverlap = 'FIELD_OVERLAP',
  FieldPageOutOfRange = 'FIELD_PAGE_OUT_OF_RANGE',
  FieldRectInvalid = 'FIELD_RECT_INVALID',
  FieldReservedZone = 'FIELD_RESERVED_ZONE',
  FieldTextUnsupported = 'FIELD_TEXT_UNSUPPORTED',
  Forbidden = 'FORBIDDEN',
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  NoSigner = 'NO_SIGNER',
  PartyCountExceeded = 'PARTY_COUNT_EXCEEDED',
  PartyDuplicate = 'PARTY_DUPLICATE',
  PartyImmutable = 'PARTY_IMMUTABLE',
  PartyRefInvalid = 'PARTY_REF_INVALID',
  RosterChangeTooLarge = 'ROSTER_CHANGE_TOO_LARGE',
  SignerWithoutField = 'SIGNER_WITHOUT_FIELD',
  SigningOrderInvalid = 'SIGNING_ORDER_INVALID',
  VersionConflict = 'VERSION_CONFLICT',
  ViewerScopeInvalid = 'VIEWER_SCOPE_INVALID'
}

/**
 * One added field. `partyId` names an existing party and `partyRef` names one this same call
 * adds. Give exactly one of the two.
 */
export type UpdateEnvelopeRosterFieldInput = {
  documentId: Scalars['ID']['input'];
  /** 1-based, as section 10.1 counts pages. */
  page: Scalars['Int']['input'];
  partyId?: InputMaybe<Scalars['ID']['input']>;
  partyRef?: InputMaybe<Scalars['String']['input']>;
  rect: FieldRectInput;
  required: Scalars['Boolean']['input'];
  type: FieldType;
};

export type UpdateEnvelopeRosterFieldRemovalInput = {
  documentId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
};

/**
 * The owner adds and removes parties and fields at any time before a terminal state (D16).
 * Permitted from `draft`, `sent` and `finalizing`. Owner only.
 *
 * **Documents never change** (R7), which is why there is no document input. From `finalizing`,
 * an addition returns the envelope to `sent`, and a removal that satisfies the barrier moves it
 * to `finalizing` and enqueues the finalize job.
 *
 * Earlier assents stay valid, because `frozenContentSha256` covers the documents only (D17).
 */
export type UpdateEnvelopeRosterInput = {
  addedFields: Array<UpdateEnvelopeRosterFieldInput>;
  addedParties: Array<UpdateEnvelopeRosterPartyInput>;
  envelopeId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['ID']['input'];
  removedFields: Array<UpdateEnvelopeRosterFieldRemovalInput>;
  removedPartyIds: Array<Scalars['ID']['input']>;
};

/**
 * One added party. The address is resolved against `users` once, exactly as a declaration
 * resolves it (section 9.2): an address with an account becomes `pending`, and an address
 * without one hangs as `invited` until that account exists.
 */
export type UpdateEnvelopeRosterPartyInput = {
  /** Read scope. Required and nonempty for a viewer. */
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  /** An opaque caller token, 1 to 200 characters. It must hold no personal data. */
  partyRef?: InputMaybe<Scalars['String']['input']>;
  /** Request-local, so an added field can name a party this same call adds. It is never stored. */
  ref: Scalars['String']['input'];
  role: PartyRole;
  /**
   * 1-based on a sequential envelope, and 0 or absent otherwise. A sequential addition must
   * sit past every position that has already signed.
   */
  signingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEnvelopeRosterPayload = {
  __typename?: 'UpdateEnvelopeRosterPayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<UpdateEnvelopeRosterError>;
};

export type UpdateFileSettingsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFileSettingsPayload = {
  __typename?: 'UpdateFileSettingsPayload';
  file: File;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  note: Note;
};

export type UpdateOriginBankError = {
  __typename?: 'UpdateOriginBankError';
  code: UpdateOriginBankErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginBankErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginBankInput = {
  accountNumber: Scalars['String']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  originId: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  recipientName: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swiftBic: Scalars['String']['input'];
};

export type UpdateOriginBankPayload = {
  __typename?: 'UpdateOriginBankPayload';
  error?: Maybe<UpdateOriginBankError>;
  origin?: Maybe<Origin>;
};

export type UpdateOriginError = {
  __typename?: 'UpdateOriginError';
  code: UpdateOriginErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['ID']['input'];
  supportedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  useCurrency?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOriginPayload = {
  __typename?: 'UpdateOriginPayload';
  error?: Maybe<UpdateOriginError>;
  origin?: Maybe<Origin>;
};

export type UpdateOriginPortalError = {
  __typename?: 'UpdateOriginPortalError';
  code: UpdateOriginPortalErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginPortalErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginPortalFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type UpdateOriginPortalInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  calloutLinkText?: InputMaybe<Scalars['String']['input']>;
  calloutLinkUrl?: InputMaybe<Scalars['String']['input']>;
  calloutText?: InputMaybe<Scalars['String']['input']>;
  faqs?: InputMaybe<Array<UpdateOriginPortalFaqInput>>;
  originId: Scalars['ID']['input'];
  shareDescription?: InputMaybe<Scalars['String']['input']>;
  shareTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOriginPortalPayload = {
  __typename?: 'UpdateOriginPortalPayload';
  error?: Maybe<UpdateOriginPortalError>;
  origin?: Maybe<Origin>;
};

export type UpdateOriginStatusError = {
  __typename?: 'UpdateOriginStatusError';
  code: UpdateOriginStatusErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateOriginStatusErrorCode {
  OriginNotFound = 'ORIGIN_NOT_FOUND'
}

export type UpdateOriginStatusInput = {
  originId: Scalars['ID']['input'];
  status: OriginStatus;
};

export type UpdateOriginStatusPayload = {
  __typename?: 'UpdateOriginStatusPayload';
  error?: Maybe<UpdateOriginStatusError>;
  origin?: Maybe<Origin>;
};

export type UpdatePaymentMethodPayload = {
  __typename?: 'UpdatePaymentMethodPayload';
  requiresAction?: Maybe<RequiresAction>;
  subscription?: Maybe<SubscriptionPlan>;
};

export type UpdatePlanCardInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  copyrightPriceQualifier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  includes?: InputMaybe<Array<UpdatePlanIncludeInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  priceOrder?: InputMaybe<Scalars['String']['input']>;
  pricingTiers: Array<UpdatePricingTierInput>;
  productId: Scalars['ID']['input'];
  subscriptionPriceQualifier?: InputMaybe<Scalars['String']['input']>;
  upsell?: InputMaybe<UpdatePlanUpsellInput>;
};

export type UpdatePlanError = {
  __typename?: 'UpdatePlanError';
  code: UpdatePlanErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdatePlanErrorCode {
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED',
  ValidationError = 'VALIDATION_ERROR'
}

export type UpdatePlanIncludeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<UpdatePlanIncludeLinkInput>;
  separator?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type UpdatePlanIncludeLinkInput = {
  text: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdatePlanInput = {
  cards?: InputMaybe<Array<UpdatePlanCardInput>>;
  enabledPlatforms?: InputMaybe<Array<Platform>>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  status?: InputMaybe<PlanStatus>;
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  error?: Maybe<UpdatePlanError>;
  plan?: Maybe<PlanSummary>;
};

export type UpdatePlanUpsellInput = {
  annualCallout?: InputMaybe<Scalars['String']['input']>;
  annualTitle?: InputMaybe<Scalars['String']['input']>;
  callout?: InputMaybe<Scalars['String']['input']>;
  membershipCompareAt?: InputMaybe<Scalars['String']['input']>;
  registrationCompareAt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePriceAmountInput = {
  currency?: InputMaybe<Scalars['Currency']['input']>;
  decimalDigits?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type UpdatePricingTierInput = {
  copyright?: InputMaybe<UpdatePriceAmountInput>;
  copyrights?: InputMaybe<Scalars['Int']['input']>;
  frequency: Frequency;
  id?: InputMaybe<Scalars['ID']['input']>;
  subscription: UpdatePriceAmountInput;
};

export type UpdateProfileError = {
  __typename?: 'UpdateProfileError';
  code: UpdateProfileErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateProfileErrorCode {
  InvalidFirstNameFormat = 'INVALID_FIRST_NAME_FORMAT',
  InvalidLastNameFormat = 'INVALID_LAST_NAME_FORMAT',
  InvalidUsernameFormat = 'INVALID_USERNAME_FORMAT',
  UsernameTaken = 'USERNAME_TAKEN'
}

export type UpdateProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  error?: Maybe<UpdateProfileError>;
  user?: Maybe<User>;
};

export type UpdateReportSettingsInput = {
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateReportSettingsPayload = {
  __typename?: 'UpdateReportSettingsPayload';
  report?: Maybe<Report>;
};

export type UpdateSettingsError = {
  __typename?: 'UpdateSettingsError';
  code: UpdateSettingsErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateSettingsErrorCode {
  InvalidTimezone = 'INVALID_TIMEZONE'
}

export type UpdateSettingsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  filePrivacy?: InputMaybe<FilePrivacy>;
  language?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<TimezoneInput>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  error?: Maybe<UpdateSettingsError>;
  user?: Maybe<User>;
};

export type UpdateSubscriptionError = {
  __typename?: 'UpdateSubscriptionError';
  code: UpdateSubscriptionErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateSubscriptionErrorCode {
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR'
}

export type UpdateSubscriptionInput = {
  chargeImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  error?: Maybe<UpdateSubscriptionError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateTeamMemberError = {
  __typename?: 'UpdateTeamMemberError';
  code: UpdateTeamMemberErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateTeamMemberErrorCode {
  MemberNotFound = 'MEMBER_NOT_FOUND'
}

export type UpdateTeamMemberInput = {
  originId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<TeamPermission>>;
  role: TeamRole;
  userId: Scalars['ID']['input'];
};

export type UpdateTeamMemberPayload = {
  __typename?: 'UpdateTeamMemberPayload';
  error?: Maybe<UpdateTeamMemberError>;
  member?: Maybe<TeamMember>;
};

export type UpdateUserStatusError = {
  __typename?: 'UpdateUserStatusError';
  code: UpdateUserStatusErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateUserStatusErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  UserNotFound = 'USER_NOT_FOUND'
}

export type UpdateUserStatusInput = {
  status: UserStatus;
  userId: Scalars['ID']['input'];
};

export type UpdateUserStatusPayload = {
  __typename?: 'UpdateUserStatusPayload';
  error?: Maybe<UpdateUserStatusError>;
  user?: Maybe<User>;
};

export type UpdateViewerPermissionsInput = {
  fileId: Scalars['ID']['input'];
  updates: Array<ViewerPermissionUpdateInput>;
  /** Admin only: act on this user instead of the caller (requires Dacr team access) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateViewerPermissionsPayload = {
  __typename?: 'UpdateViewerPermissionsPayload';
  file?: Maybe<File>;
};

export type UploadError = {
  __typename?: 'UploadError';
  code: UploadErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UploadErrorCode {
  SizeTooLarge = 'SIZE_TOO_LARGE'
}

export type UploadField = {
  __typename?: 'UploadField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UploadInfo = {
  __typename?: 'UploadInfo';
  headers: Scalars['Json']['output'];
  url: Scalars['String']['output'];
};

export type UploadInfringingFileError = {
  __typename?: 'UploadInfringingFileError';
  code: UploadInfringingFileErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UploadInfringingFileErrorCode {
  CopyrightNotFound = 'COPYRIGHT_NOT_FOUND',
  LimitExceeded = 'LIMIT_EXCEEDED'
}

export type UploadInfringingFileInput = {
  copyrightId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  /** Admin only (Dacr team access): create the report for this user */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UploadInfringingFilePayload = {
  __typename?: 'UploadInfringingFilePayload';
  error?: Maybe<UploadInfringingFileError>;
  headers?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadInput = {
  copyrightOwnerID: Scalars['ID']['input'];
  files: Array<FileMetadataInput>;
  folderId: Scalars['ID']['input'];
};

/** An upload that never produced a file, so the filename is all that is known. */
export type UploadNotificationDetails = {
  __typename?: 'UploadNotificationDetails';
  filename: Scalars['String']['output'];
};

export type UploadPayload = {
  __typename?: 'UploadPayload';
  error?: Maybe<UploadError>;
  uploads: Array<UploadInfo>;
};

export type User = {
  __typename?: 'User';
  archivedFiles: ArchivedFileConnection;
  avatar: Image;
  bio?: Maybe<Scalars['String']['output']>;
  copyrightOwners: Array<CopyrightOwner>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  filesByCategory: Array<FileCategoryCount>;
  filesOverTime: FilesOverTime;
  id: Scalars['ID']['output'];
  invoices: InvoiceConnection;
  /** Most recent sign-in, including sessions that have since signed out */
  lastLogin?: Maybe<Session>;
  latestSession?: Maybe<Session>;
  name: Scalars['String']['output'];
  notes: NoteConnection;
  notifications: NotificationConnection;
  onboarding: OnboardingStatus;
  origin: Origin;
  permissions: Array<Permission>;
  /** Infringement report credits available to the user */
  reportCredits: Scalars['Int']['output'];
  revenue: UserRevenue;
  revenueOverTime: RevenueOverTimeResult;
  settings: UserSettings;
  status: UserStatus;
  storageUsed: Scalars['String']['output'];
  subscription: SubscriptionPlan;
  tips: Array<Tip>;
  title?: Maybe<Scalars['String']['output']>;
  totalFiles: Scalars['Int']['output'];
  /**
   * The next charge for the user's current plan — the billing-cycle (registrations) invoice when
   * there is one, otherwise the subscription renewal. Same source as web's "Next billings".
   * Null when nothing is due.
   */
  upcomingBilling?: Maybe<UpcomingBilling>;
  username: Scalars['String']['output'];
};


export type UserArchivedFilesArgs = {
  input: ArchiveFilesInput;
};


export type UserFilesByCategoryArgs = {
  origin: Scalars['ID']['input'];
};


export type UserFilesOverTimeArgs = {
  input: UserFilesOverTimeInput;
};


export type UserInvoicesArgs = {
  input: InvoicesInput;
};


export type UserLatestSessionArgs = {
  client?: InputMaybe<Scalars['String']['input']>;
};


export type UserNotesArgs = {
  input: UserNotesInput;
};


export type UserNotificationsArgs = {
  input: NotificationsInput;
};


export type UserRevenueArgs = {
  input: UserRevenueInput;
};


export type UserRevenueOverTimeArgs = {
  input: UserRevenueOverTimeInput;
};


export type UserStorageUsedArgs = {
  origin: Scalars['ID']['input'];
};


export type UserTotalFilesArgs = {
  origin: Scalars['ID']['input'];
};

/** One document as it appears to one user, with the state of that user's own party on it. */
export type UserDocument = {
  __typename?: 'UserDocument';
  completedAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  currentSha256?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  documentOrder: Scalars['Int']['output'];
  documentTitle: Scalars['String']['output'];
  envelopeId: Scalars['ID']['output'];
  envelopeStatus: EnvelopeStatus;
  envelopeTitle: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Float']['output']>;
  /** `${partyId}#${documentId}`, the Elasticsearch `_id`. */
  id: Scalars['ID']['output'];
  /** True when the envelope is waiting on this caller. */
  isNext: Scalars['Boolean']['output'];
  ownerId: Scalars['ID']['output'];
  pageCount?: Maybe<Scalars['Int']['output']>;
  partyId: Scalars['ID']['output'];
  partyRole: PartyRole;
  /** PENDING is still to sign, SIGNED is signed, DECLINED is rejected. */
  partyStatus: PartyStatus;
  /** How many required fields this caller owns on this document. */
  requiredFieldCount: Scalars['Int']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['Float']['output']>;
  signedAt?: Maybe<Scalars['Float']['output']>;
  signingMode: SigningMode;
  signingPosition: Scalars['Int']['output'];
};

export type UserDocumentEdge = {
  __typename?: 'UserDocumentEdge';
  cursor: Scalars['String']['output'];
  node: UserDocument;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
  revenue: UserRevenue;
  totalFiles: Scalars['Int']['output'];
};


export type UserEdgeRevenueArgs = {
  currency: Scalars['Currency']['input'];
};

export type UserFilesOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['String']['input'];
};

export type UserRevenue = {
  __typename?: 'UserRevenue';
  breakdown: Array<RevenueCategoryTotal>;
  total: Money;
};

export type UserRevenueInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserRevenueOverTimeInput = {
  currency: Scalars['Currency']['input'];
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  revenueType: RevenueType;
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  dateFormat: Scalars['String']['output'];
  filePrivacy: FilePrivacy;
  language?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
};

export type UserSort = {
  direction: SortDirection;
  field: UserSortField;
};

export enum UserSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Registrations = 'REGISTRATIONS',
  TaxRevenue = 'TAX_REVENUE'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED'
}

export type UsersComparison = {
  __typename?: 'UsersComparison';
  change: PercentChange;
  total: Scalars['Int']['output'];
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersDataPoint = {
  __typename?: 'UsersDataPoint';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type UsersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserSort>;
};

export type UsersOverTime = {
  __typename?: 'UsersOverTime';
  comparison?: Maybe<UsersComparison>;
  previousSeries?: Maybe<Array<UsersDataPoint>>;
  series: Array<UsersDataPoint>;
  total: Scalars['Int']['output'];
};

export type UsersOverTimeInput = {
  compareEndDate?: InputMaybe<Scalars['Date']['input']>;
  compareStartDate?: InputMaybe<Scalars['Date']['input']>;
  compareTo?: InputMaybe<ComparisonPeriod>;
  endDate: Scalars['Date']['input'];
  groupBy: TimeGrouping;
  locale?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyIdentityInput = {
  type: IdentityVerificationType;
};

export type VerifyIdentityPayload = {
  __typename?: 'VerifyIdentityPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VideoAnalysis = Analysis & {
  __typename?: 'VideoAnalysis';
  attributes: Array<Attribute>;
  duration: Scalars['Float']['output'];
  feedback?: Maybe<FeedbackRating>;
  frames: Array<Scalars['String']['output']>;
  markers: Array<Maybe<Marker>>;
  summary: Scalars['String']['output'];
  tracks: Array<Track>;
  transcript: TextWithTimestamp;
};

export type VideoMatch = Match & {
  __typename?: 'VideoMatch';
  end: Scalars['Float']['output'];
  file: ReportFile;
  frames: Array<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<ScoreLevel>;
  location: Scalars['String']['output'];
  markers: Array<Maybe<Marker>>;
  score?: Maybe<Scalars['Float']['output']>;
  segmentUrl?: Maybe<Scalars['String']['output']>;
  start: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Viewer = EmailInvite | ViewerEntity;

export type ViewerEdge = {
  __typename?: 'ViewerEdge';
  cursor: Scalars['String']['output'];
  node: Viewer;
};

export type ViewerEntity = {
  __typename?: 'ViewerEntity';
  entity: Entity;
  permissions: Array<FilePermission>;
  role: FileRole;
};

export type ViewerPermissionUpdateInput = {
  canDownload: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ViewersConnection = {
  __typename?: 'ViewersConnection';
  edges: Array<ViewerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ViewersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type VoidEnvelopeError = {
  __typename?: 'VoidEnvelopeError';
  code: VoidEnvelopeErrorCode;
  message: Scalars['String']['output'];
};

export enum VoidEnvelopeErrorCode {
  EnvelopeNotFound = 'ENVELOPE_NOT_FOUND',
  EnvelopeNotVoidable = 'ENVELOPE_NOT_VOIDABLE',
  Forbidden = 'FORBIDDEN',
  /**
   * The key was already used on another envelope, which is a caller defect and not a replay.
   *
   * A replay of the same key on the same envelope is **success** and returns the recorded
   * state, per section 8.4. `SignEnvelopeErrorCode` has carried this member since it was
   * written, and `DeclineEnvelopeErrorCode` gained it on 2026-10-09.
   */
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  ReasonInvalid = 'REASON_INVALID',
  VersionConflict = 'VERSION_CONFLICT'
}

/**
 * The owner withdraws the envelope, from `draft` or `sent` only. A void from `finalizing` is
 * `ENVELOPE_NOT_VOIDABLE`: every assent has committed, so the envelope is signed.
 */
export type VoidEnvelopeInput = {
  envelopeId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  idempotencyKey: Scalars['ID']['input'];
  /** 1 to 500 characters. It reaches the parties on the `Voided` event. */
  reason: Scalars['String']['input'];
};

export type VoidEnvelopePayload = {
  __typename?: 'VoidEnvelopePayload';
  envelope?: Maybe<Envelope>;
  error?: Maybe<VoidEnvelopeError>;
};

export type VoidInvoiceError = {
  __typename?: 'VoidInvoiceError';
  code: VoidInvoiceErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum VoidInvoiceErrorCode {
  InvalidStatus = 'INVALID_STATUS',
  NotFound = 'NOT_FOUND'
}

export type VoidInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type VoidInvoicePayload = {
  __typename?: 'VoidInvoicePayload';
  error?: Maybe<VoidInvoiceError>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
};

export type OriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginsQuery = { __typename?: 'Query', origins: Array<{ __typename?: 'Origin', id: string, name: string, currency: string, flag: { __typename?: 'Image', url: string }, logo: { __typename?: 'Logo', white: { __typename?: 'Image', url: string }, black: { __typename?: 'Image', url: string } } }> };

export type VerifyIdentityMutationVariables = Exact<{
  input: VerifyIdentityInput;
}>;


export type VerifyIdentityMutation = { __typename?: 'Mutation', verifyIdentity: { __typename?: 'VerifyIdentityPayload', status: string, clientSecret?: string | null, sessionId?: string | null, message?: string | null, verifiedAt?: any | null } };

export type CopyrightFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CopyrightFileQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, name: string, description?: string | null, type: FileType, role: FileRole, permissions: Array<FilePermission>, asset?:
      | { __typename?: 'DocumentAsset', totalPages?: number | null, documentUrl?: string | null, previewImageUrl: string }
      | { __typename?: 'ImageAsset', previewImageUrl: string }
      | { __typename?: 'StreamAsset', streamUrl?: string | null, previewImageUrl: string }
     | null, metadata: { __typename?: 'FileMetadata', originalFilename: string, size: string }, settings: { __typename?: 'FileSettings', isPrivate: boolean }, copyright: { __typename?: 'FileCopyright', id?: string | null, status: CopyrightStatus, registrations: Array<{ __typename?: 'FileRegistration', certificateUrl?: string | null, timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } } }> }, owner: { __typename?: 'CopyrightOwner', id: string, referenceId: string, name: string, avatar: { __typename?: 'Image', url: string } }, registrant: { __typename?: 'User', id: string, name: string }, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> }, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> }, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
          | { __typename?: 'EmailInvite' }
          | { __typename?: 'ViewerEntity', entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
              | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> }, analysis?:
      | { __typename?: 'AudioAnalysis', feedback?: FeedbackRating | null, summary: string, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, tracks: Array<{ __typename?: 'Track', summary: string, url: string, start?: number | null, end?: number | null, duration?: number | null, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, stems: { __typename?: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename?: 'Stem', name: string, url: string, sheetMusic?: { __typename?: 'SheetMusic', url: string, preview: string } | null }> } }>, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null> }
      | { __typename?: 'GenericAnalysis', feedback?: FeedbackRating | null, summary: string, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null> }
      | { __typename?: 'VideoAnalysis', frames: Array<string>, feedback?: FeedbackRating | null, summary: string, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, tracks: Array<{ __typename?: 'Track', summary: string, url: string, start?: number | null, end?: number | null, duration?: number | null, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, transcript: { __typename?: 'TextWithTimestamp', url: string, preview: Array<{ __typename?: 'TextWithTimestampPreview', text: string, timestamp: string }> }, stems: { __typename?: 'Stems', amplitudeUrl: string, breakdown: Array<{ __typename?: 'Stem', name: string, url: string, sheetMusic?: { __typename?: 'SheetMusic', url: string, preview: string } | null }> } }>, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null> }
     | null, notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, content: { __typename?: 'I18N', key: string }, actions: Array<{ __typename?: 'NotificationAction', type: NotificationActionType, buttonType: ButtonType, label: { __typename?: 'I18N', key: string } }>, details?:
        | { __typename?: 'CopyrightNotificationDetails' }
        | { __typename?: 'InfringementNotificationDetails' }
        | { __typename?: 'InviteNotificationDetails', from: { __typename?: 'User', id: string, name: string } }
        | { __typename?: 'ReportNotificationDetails' }
        | { __typename?: 'UploadNotificationDetails' }
       | null } | null> } | null };

export type FolderByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  sort?: InputMaybe<ItemSort>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FolderByPathQuery = { __typename?: 'Query', folderByPath?: { __typename?: 'Folder', id: string, name: string, path: string, createdAt: any, totalFiles: number, items: { __typename?: 'ItemsConnection', totalFiles: number, edges: Array<{ __typename?: 'ItemEdge', cursor: string, node:
          | { __typename?: 'File', id: string, name: string, type: FileType, description?: string | null, role: FileRole, permissions: Array<FilePermission>, copyright: { __typename?: 'FileCopyright', id?: string | null, status: CopyrightStatus, registrations: Array<{ __typename?: 'FileRegistration', certificateUrl?: string | null, expiresAt?: any | null, timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } } }> }, metadata: { __typename?: 'FileMetadata', originalFilename: string, size: string }, asset?:
              | { __typename?: 'DocumentAsset', previewImageUrl: string }
              | { __typename?: 'ImageAsset', previewImageUrl: string }
              | { __typename?: 'StreamAsset', previewImageUrl: string }
             | null, settings: { __typename?: 'FileSettings', isPrivate: boolean }, registrant: { __typename?: 'User', id: string, name: string }, owner: { __typename?: 'CopyrightOwner', id: string, referenceId: string, name: string, avatar: { __typename?: 'Image', url: string } }, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
                  | { __typename?: 'EmailInvite' }
                  | { __typename?: 'EntityWithRole', role: FileRole, entity:
                      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                     }
                 }> }, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
                  | { __typename?: 'EmailInvite' }
                  | { __typename?: 'EntityWithRole', role: FileRole, entity:
                      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                     }
                 }> }, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
                  | { __typename?: 'EmailInvite' }
                  | { __typename?: 'ViewerEntity', entity:
                      | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                      | { __typename?: 'User', id: string, name: string, avatar: { __typename?: 'Image', url: string } }
                     }
                 }> } }
          | { __typename?: 'Folder', id: string, name: string, path: string, createdAt: any, totalFiles: number }
         }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };

export type AudioMatchFieldsFragment = { __typename?: 'AudioMatch', id: string, location: string, summary?: string | null, level?: ScoreLevel | null, matchingUrl: string, amplitudeUrl: string, start: number, end: number, duration: number, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, stem: { __typename?: 'Stem', name: string, url: string } } & { ' $fragmentName'?: 'AudioMatchFieldsFragment' };

export type ImageMatchFieldsFragment = { __typename?: 'ImageMatch', id: string, location: string, summary?: string | null, url: string, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null> } & { ' $fragmentName'?: 'ImageMatchFieldsFragment' };

export type SetMatchVisibilityMutationVariables = Exact<{
  input: SetMatchVisibilityInput;
}>;


export type SetMatchVisibilityMutation = { __typename?: 'Mutation', setMatchVisibility: { __typename?: 'SetMatchVisibilityPayload', report?: { __typename?: 'Report', id: string } | null } };

export type MatchBreakdownFragment = { __typename?: 'MatchCategoryBreakdown', copyright:
    | (
      { __typename?: 'AudioMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'AudioMatchFieldsFragment': AudioMatchFieldsFragment } }
    )
    | (
      { __typename?: 'ImageMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'ImageMatchFieldsFragment': ImageMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TextMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'TextMatchFieldsFragment': TextMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TranscriptMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'TranscriptMatchFieldsFragment': TranscriptMatchFieldsFragment } }
    )
    | (
      { __typename?: 'VideoMatch', id: string, location: string, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, metadata: { __typename?: 'FileMetadata', originalFilename: string }, copyright: { __typename?: 'FileCopyright', id?: string | null } }
        | { __typename?: 'InfringingFile' }
       }
      & { ' $fragmentRefs'?: { 'VideoMatchFieldsFragment': VideoMatchFieldsFragment } }
    )
  , infringingFile:
    | (
      { __typename?: 'AudioMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, hidden?: boolean | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'AudioMatchFieldsFragment': AudioMatchFieldsFragment } }
    )
    | (
      { __typename?: 'ImageMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, hidden?: boolean | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'ImageMatchFieldsFragment': ImageMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TextMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, hidden?: boolean | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'TextMatchFieldsFragment': TextMatchFieldsFragment } }
    )
    | (
      { __typename?: 'TranscriptMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, hidden?: boolean | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'TranscriptMatchFieldsFragment': TranscriptMatchFieldsFragment } }
    )
    | (
      { __typename?: 'VideoMatch', id: string, location: string, summary?: string | null, title: string, score?: number | null, level?: ScoreLevel | null, hidden?: boolean | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, file:
        | { __typename?: 'File' }
        | { __typename?: 'InfringingFile', id: string, name: string, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }
       }
      & { ' $fragmentRefs'?: { 'VideoMatchFieldsFragment': VideoMatchFieldsFragment } }
    )
   } & { ' $fragmentName'?: 'MatchBreakdownFragment' };

export type TextMatchFieldsFragment = { __typename?: 'TextMatch', id: string, location: string, level?: ScoreLevel | null, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, urls: Array<{ __typename?: 'DocumentUrl', page: number, url: string }>, coords: Array<{ __typename?: 'Coords', x1: number, x2: number, y1: number, y2: number, page: number }> } & { ' $fragmentName'?: 'TextMatchFieldsFragment' };

export type TranscriptMatchFieldsFragment = { __typename?: 'TranscriptMatch', id: string, location: string, summary?: string | null, score?: number | null, level?: ScoreLevel | null, start: number, end: number, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null>, transcript: Array<{ __typename?: 'Transcript', timestamp: string, text: string, highlight: boolean } | null> } & { ' $fragmentName'?: 'TranscriptMatchFieldsFragment' };

export type VideoMatchFieldsFragment = { __typename?: 'VideoMatch', id: string, location: string, summary?: string | null, level?: ScoreLevel | null, frames: Array<string>, segmentUrl?: string | null, start: number, end: number, markers: Array<{ __typename?: 'Marker', hash?: string | null, color: string, shine: boolean, visible?: boolean | null } | null> } & { ' $fragmentName'?: 'VideoMatchFieldsFragment' };

export type MatchCategoryBreakdownQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type: MatchCategoryType;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchCategoryBreakdownQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, matches: { __typename?: 'Matches', categories: Array<{ __typename?: 'MatchCategory', type: MatchCategoryType, total: number, breakdown: { __typename?: 'MatchCategoryBreakdownConnection', edges: Array<{ __typename?: 'MatchCategoryBreakdownEdge', cursor: string, node: (
              { __typename?: 'MatchCategoryBreakdown' }
              & { ' $fragmentRefs'?: { 'MatchBreakdownFragment': MatchBreakdownFragment } }
            ) }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } }> } } | null };

export type InfringementListQueryVariables = Exact<{
  input?: InputMaybe<InfringementsInput>;
}>;


export type InfringementListQuery = { __typename?: 'Query', infringements: { __typename?: 'InfringementConnection', totalFlags: number, totalReports: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'InfringementEdge', cursor: string, node: { __typename?: 'Infringement', id: string, label: InfringementLabel, timestamp: any, accepted?: boolean | null, copyrights: Array<{ __typename?: 'File', id: string, name: string, type: FileType, asset?:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           | null, copyright: { __typename?: 'FileCopyright', id?: string | null } }>, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, copyrightId?: string | null, type: FileType, asset:
            | { __typename?: 'DocumentAsset', previewImageUrl: string }
            | { __typename?: 'ImageAsset', previewImageUrl: string }
            | { __typename?: 'StreamAsset', previewImageUrl: string }
           }, audioBundle?: { __typename?: 'AudioBundle', acceptedWorks: Array<{ __typename?: 'AudioAcceptedWork', fileId: string, accepted: boolean, matchSources: Array<string> }> } | null, matches?: { __typename?: 'MatchSummary', score?: number | null, level: ScoreLevel, breakdown: Array<{ __typename?: 'MatchSummaryBreakdown', level: ScoreLevel, score: number, type: MatchCategoryType }> } | null, report?: { __typename?: 'Report', id: string, status: ReportStatus } | null } }> } };

export type ReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, role: ReportRole, timestamp: any, summary: string, score: number, level: ScoreLevel, feedback?: FeedbackRating | null, copyright: { __typename?: 'File', id: string, name: string, type: FileType, metadata: { __typename?: 'FileMetadata', originalFilename: string }, asset?:
        | { __typename?: 'DocumentAsset', previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', previewImageUrl: string }
       | null, copyright: { __typename?: 'FileCopyright', id?: string | null }, analysis?:
        | { __typename?: 'AudioAnalysis' }
        | { __typename?: 'GenericAnalysis' }
        | { __typename?: 'VideoAnalysis', duration: number }
       | null }, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, copyrightId?: string | null, attributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, asset:
        | { __typename?: 'DocumentAsset', totalPages?: number | null, documentUrl?: string | null, previewImageUrl: string }
        | { __typename?: 'ImageAsset', previewImageUrl: string }
        | { __typename?: 'StreamAsset', streamUrl?: string | null, previewImageUrl: string }
       }, audioBundle: { __typename?: 'AudioBundle', noMatch?: boolean | null, searchedScopeComplete: boolean, catalogueComplete: boolean, acceptedWorksComplete: boolean, totalWindows?: number | null, processedWindows?: number | null, unprocessedWindows?: number | null, regularStatus: { __typename?: 'AudioMethodStatus', state: string, outcome?: string | null, reason?: string | null, completeCoverage?: boolean | null, catalogueComplete?: boolean | null }, coverStatus: { __typename?: 'AudioMethodStatus', state: string, outcome?: string | null, reason?: string | null, completeCoverage?: boolean | null, catalogueComplete?: boolean | null }, acceptedWorks: Array<{ __typename?: 'AudioAcceptedWork', fileId: string, userId?: string | null, registrationId?: string | null, accepted: boolean, matchSources: Array<string>, coverWitnessesComplete?: boolean | null, regular: Array<{ __typename?: 'AudioRegularEvidence', hashType: string, similarityScore: number, scoreKind: string }>, coverWitnesses: Array<{ __typename?: 'AudioCoverWitness', windowIndex: number, startMs?: number | null, spanMs?: number | null, method: string, registrationId: string, viewId: string, score: number, gate: number, topTied: boolean, admitted: boolean }> }> }, matches: { __typename?: 'Matches', total: number, categories: Array<{ __typename?: 'MatchCategory', type: MatchCategoryType, total: number, breakdown: { __typename?: 'MatchCategoryBreakdownConnection', edges: Array<{ __typename?: 'MatchCategoryBreakdownEdge', cursor: string, node: (
              { __typename?: 'MatchCategoryBreakdown' }
              & { ' $fragmentRefs'?: { 'MatchBreakdownFragment': MatchBreakdownFragment } }
            ) }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } }> }, timeline?: { __typename?: 'TimelineGroup', infringingFile: { __typename?: 'Timeline', transcript?: Array<string> | null, audioUrl: string, frames?: Array<string> | null, duration: number }, copyright: { __typename?: 'Timeline', transcript?: Array<string> | null, audioUrl: string, frames?: Array<string> | null, duration: number } } | null, pdf: { __typename?: 'ReportPdf', status: ReportPdfStatus, url?: string | null }, settings: { __typename?: 'ReportSettings', isPrivate: boolean }, viewers: { __typename?: 'ReportViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ReportViewerEdge', cursor: string, role: ReportRole, node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
              | { __typename?: 'Organization' }
              | { __typename?: 'User', id: string, name: string }
             }
          | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
         }> } } | null };

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'CreateFeedbackPayload', success: boolean, feedbackId?: string | null } };

export type RemoveFeedbackMutationVariables = Exact<{
  input: RemoveFeedbackInput;
}>;


export type RemoveFeedbackMutation = { __typename?: 'Mutation', removeFeedback: { __typename?: 'RemoveFeedbackPayload', success: boolean } };

export type FileViewersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileViewersQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddViewersMutationVariables = Exact<{
  input: AddViewersInput;
}>;


export type AddViewersMutation = { __typename?: 'Mutation', addViewers: { __typename?: 'AddViewersPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type UpdateViewerPermissionsMutationVariables = Exact<{
  input: UpdateViewerPermissionsInput;
}>;


export type UpdateViewerPermissionsMutation = { __typename?: 'Mutation', updateViewerPermissions: { __typename?: 'UpdateViewerPermissionsPayload', file?: { __typename?: 'File', id: string, viewers: { __typename?: 'ViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ViewerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'ViewerEntity', role: FileRole, permissions: Array<FilePermission>, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type FileAuthorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileAuthorsQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', role: FileRole, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddAuthorsMutationVariables = Exact<{
  input: AddAuthorsInput;
}>;


export type AddAuthorsMutation = { __typename?: 'Mutation', addAuthors: { __typename?: 'AddAuthorsPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, authors: { __typename?: 'AuthorsConnection', totalCount: number, edges: Array<{ __typename?: 'AuthorEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'EntityWithRole', role: FileRole, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type FileOwnersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileOwnersQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
          | { __typename?: 'EmailInvite', email: string }
          | { __typename?: 'EntityWithRole', role: FileRole, entity:
              | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                  | { __typename?: 'Organization' }
                  | { __typename?: 'User', id: string, name: string }
                 }
              | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
             }
         }> } } | null };

export type AddCoOwnersMutationVariables = Exact<{
  input: AddCoOwnersInput;
}>;


export type AddCoOwnersMutation = { __typename?: 'Mutation', addCoOwners: { __typename?: 'AddCoOwnersPayload', error?: { __typename?: 'AddCoOwnersError', code: AddCoOwnersErrorCode, message?: string | null } | null, file?: { __typename?: 'File', id: string, coOwners: { __typename?: 'CoOwnersConnection', totalCount: number, edges: Array<{ __typename?: 'CoOwnerEdge', node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'EntityWithRole', role: FileRole, entity:
                | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                    | { __typename?: 'Organization' }
                    | { __typename?: 'User', id: string, name: string }
                   }
                | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
               }
           }> } } | null } };

export type MoveFoldersQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type MoveFoldersQuery = { __typename?: 'Query', folderByPath?: { __typename?: 'Folder', id: string, name: string, path: string, items: { __typename?: 'ItemsConnection', edges: Array<{ __typename?: 'ItemEdge', node:
          | { __typename?: 'File' }
          | { __typename?: 'Folder', id: string, name: string, path: string, totalFiles: number }
         }> } } | null };

export type RemoveViewerMutationVariables = Exact<{
  input: RemoveViewerInput;
}>;


export type RemoveViewerMutation = { __typename?: 'Mutation', removeViewer: { __typename?: 'RemoveViewersPayload', success: boolean } };

export type RemoveAuthorMutationVariables = Exact<{
  input: RemoveAuthorInput;
}>;


export type RemoveAuthorMutation = { __typename?: 'Mutation', removeAuthor: { __typename?: 'RemoveAuthorsPayload', success: boolean } };

export type RemoveCoOwnerMutationVariables = Exact<{
  input: RemoveCoOwnerInput;
}>;


export type RemoveCoOwnerMutation = { __typename?: 'Mutation', removeCoOwner: { __typename?: 'RemoveCoOwnerPayload', success: boolean } };

export type CheckerDetectionResultFragment = { __typename?: 'DnaDetectionResult', infringementMatchIds?: Array<string> | null, outcome: string, completeCoverage: boolean, incompleteReason?: string | null, windowSeconds?: number | null, capturedAudioSeconds?: number | null, processedAudioSeconds?: number | null, baseFingerprintProcessed: boolean, findings: Array<{ __typename?: 'DnaDetectionFinding', fileDataId?: string | null, registrationId?: string | null, algorithm: string, modality: string, scorePercent?: number | null, score?: number | null, scoreKind: string, validationPending: boolean, riskLevel: ScoreLevel, strict?: boolean | null, copyrightId?: string | null, title?: string | null, url?: string | null, metadataStatus: string, audioCompositionEvidence?: { __typename?: 'DnaAudioCompositionEvidence', policyScore: number, policyMargin?: number | null, rawScore: number, referenceStartSeconds?: number | null, supporting: Array<number>, supportKind: string, confirmed: boolean, exactLaneMatch: boolean, arm: string, rule: string, modelVersion: string, policyId: string } | null }> } & { ' $fragmentName'?: 'CheckerDetectionResultFragment' };

export type StartDnaCaptureMutationVariables = Exact<{
  input: DnaCaptureInput;
}>;


export type StartDnaCaptureMutation = { __typename?: 'Mutation', startDnaCapture: { __typename?: 'DnaCaptureSession', id: string, expiresAt: any, batchSeconds: number, minAudioSeconds: number, windowSeconds: number, maxAudioSeconds: number, maxBatchBytes: number } };

export type DetectDnaCaptureBatchMutationVariables = Exact<{
  input: DnaCaptureBatchInput;
}>;


export type DetectDnaCaptureBatchMutation = { __typename?: 'Mutation', detectDnaCaptureBatch: (
    { __typename?: 'DnaDetectionResult' }
    & { ' $fragmentRefs'?: { 'CheckerDetectionResultFragment': CheckerDetectionResultFragment } }
  ) };

export type StopDnaCaptureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopDnaCaptureMutation = { __typename?: 'Mutation', stopDnaCapture: { __typename?: 'DnaCaptureStopPayload', success: boolean, result?: (
      { __typename?: 'DnaDetectionResult' }
      & { ' $fragmentRefs'?: { 'CheckerDetectionResultFragment': CheckerDetectionResultFragment } }
    ) | null } };

export type CreateDnaDetectionMultipartUploadMutationVariables = Exact<{
  input: DnaDetectionMultipartUploadInput;
}>;


export type CreateDnaDetectionMultipartUploadMutation = { __typename?: 'Mutation', createDnaDetectionMultipartUpload: { __typename?: 'DnaDetectionMultipartUpload', id: string, expiresAt: any, maxBytes: number, sizeBytes: number, partSizeBytes: number, partCount: number, parts: Array<{ __typename?: 'DnaDetectionUploadPart', partNumber: number, url: string }> } };

export type SignDnaDetectionUploadPartsMutationVariables = Exact<{
  input: DnaSignDetectionUploadPartsInput;
}>;


export type SignDnaDetectionUploadPartsMutation = { __typename?: 'Mutation', signDnaDetectionUploadParts: Array<{ __typename?: 'DnaDetectionUploadPart', partNumber: number, url: string }> };

export type StartDnaFileDetectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StartDnaFileDetectionMutation = { __typename?: 'Mutation', startDnaFileDetection: { __typename?: 'DnaFileDetectionJob', id: string, status: DnaFileDetectionStatus } };

export type CancelDnaFileDetectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelDnaFileDetectionMutation = { __typename?: 'Mutation', cancelDnaFileDetection: { __typename?: 'DnaFileDetectionJob', id: string, status: DnaFileDetectionStatus } };

export type DnaFileDetectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DnaFileDetectionQuery = { __typename?: 'Query', dnaFileDetection: { __typename?: 'DnaFileDetectionJob', id: string, status: DnaFileDetectionStatus, totalBytes: number, transferredBytes: number, windowsDone: number, windowsTotal: number, result?: (
      { __typename?: 'DnaDetectionResult' }
      & { ' $fragmentRefs'?: { 'CheckerDetectionResultFragment': CheckerDetectionResultFragment } }
    ) | null, error?: { __typename?: 'DnaDetectionJobError', code: string, retryable: boolean } | null } };

export type AddReportViewersMutationVariables = Exact<{
  input: AddReportViewersInput;
}>;


export type AddReportViewersMutation = { __typename?: 'Mutation', addReportViewers: { __typename?: 'AddReportViewersPayload', error?: { __typename?: 'AddReportViewersError', message?: string | null } | null, report?: { __typename?: 'Report', id: string, settings: { __typename?: 'ReportSettings', isPrivate: boolean }, viewers: { __typename?: 'ReportViewersConnection', totalCount: number, edges: Array<{ __typename?: 'ReportViewerEdge', cursor: string, role: ReportRole, node:
            | { __typename?: 'EmailInvite', email: string }
            | { __typename?: 'Organization', id: string, name: string, avatar: { __typename?: 'Image', url: string }, owner:
                | { __typename?: 'Organization' }
                | { __typename?: 'User', id: string, name: string }
               }
            | { __typename?: 'User', id: string, name: string, username: string, avatar: { __typename?: 'Image', url: string } }
           }> } } | null } };

export type RemoveReportViewerMutationVariables = Exact<{
  input: RemoveReportViewerInput;
}>;


export type RemoveReportViewerMutation = { __typename?: 'Mutation', removeReportViewer: { __typename?: 'RemoveReportViewerPayload', success: boolean } };

export type UpdateReportSettingsMutationVariables = Exact<{
  input: UpdateReportSettingsInput;
}>;


export type UpdateReportSettingsMutation = { __typename?: 'Mutation', updateReportSettings: { __typename?: 'UpdateReportSettingsPayload', report?: { __typename?: 'Report', id: string, settings: { __typename?: 'ReportSettings', isPrivate: boolean } } | null } };

export type InfringingFileDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InfringingFileDetailsQuery = { __typename?: 'Query', infringement: { __typename?: 'Infringement', id: string, infringingFile: { __typename?: 'InfringingFile', id: string, name: string, type: FileType, copyrightId?: string | null, asset:
        | { __typename: 'DocumentAsset', previewImageUrl: string }
        | { __typename: 'ImageAsset', previewImageUrl: string }
        | { __typename: 'StreamAsset', streamUrl?: string | null, previewImageUrl: string }
      , metadata?: { __typename?: 'InfringingFileMetadata', sourceLabel: string, captureType?: string | null, sourceUrl?: string | null, recordedAt?: any | null, durationSeconds?: number | null, owner?: { __typename?: 'InfringingCopyrightOwner', id: string, name: string } | null, recognizedOrigins: Array<{ __typename?: 'InfringingFileRecognizedOrigin', timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } } }> } | null, currentCopyright?: { __typename?: 'InfringingFileCurrentCopyright', id: string, status: InfringingCopyrightStatus, sourceUrl?: string | null, owner?: { __typename?: 'InfringingCopyrightOwner', id: string, name: string } | null, recognizedOrigins: Array<{ __typename?: 'InfringingFileRecognizedOrigin', timestamp?: any | null, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } } }> } | null } } };

export type InfringingRegistrationFallbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InfringingRegistrationFallbackQuery = { __typename?: 'Query', file?: { __typename?: 'File', id: string, asset?:
      | { __typename: 'DocumentAsset', previewImageUrl: string }
      | { __typename: 'ImageAsset', previewImageUrl: string }
      | { __typename: 'StreamAsset', previewImageUrl: string }
     | null, analysis?:
      | { __typename: 'AudioAnalysis', tracks: Array<{ __typename?: 'Track', end?: number | null }> }
      | { __typename: 'GenericAnalysis' }
      | { __typename: 'VideoAnalysis', duration: number }
     | null } | null };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'CreateReportPayload', success: boolean, error?: { __typename?: 'CreateReportError', code: CreateReportErrorCode, message?: string | null } | null } };

export type ReportProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportProductsQuery = { __typename?: 'Query', reportProducts: Array<{ __typename?: 'ReportProduct', id: string, name: string, description: string, callout?: string | null, credits: number, price: { __typename?: 'Pricing', amount: number, currencyCode: string } }> };

export type UploadInfringingFileMutationVariables = Exact<{
  input: UploadInfringingFileInput;
}>;


export type UploadInfringingFileMutation = { __typename?: 'Mutation', uploadInfringingFile: { __typename?: 'UploadInfringingFilePayload', id?: string | null, url?: string | null, headers?: any | null, error?: { __typename?: 'UploadInfringingFileError', code: UploadInfringingFileErrorCode, message?: string | null } | null } };

export type PurchaseReportCreditsMutationVariables = Exact<{
  input: PurchaseReportCreditsInput;
}>;


export type PurchaseReportCreditsMutation = { __typename?: 'Mutation', purchaseReportCredits: { __typename?: 'PurchaseReportCreditsPayload', requiresAction?: { __typename?: 'RequiresAction', clientSecret: string } | null, error?: { __typename?: 'PurchaseReportCreditsError', code: PurchaseReportCreditsErrorCode, message?: string | null } | null } };

export type EstimateRegistrationCostQueryVariables = Exact<{
  input: EstimateRegistrationCostInput;
}>;


export type EstimateRegistrationCostQuery = { __typename?: 'Query', estimateRegistrationCost?: { __typename?: 'EstimateRegistrationCost', total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCost', description: string, origin: { __typename?: 'Origin', id: string, name: string, flag: { __typename?: 'Image', url: string } }, total: { __typename?: 'Money', amount: string, formatted: string }, breakdown: Array<{ __typename?: 'RegistrationCostItem', id: string, name: string, total: { __typename?: 'Money', amount: string, formatted: string } }> }> } | null };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'Query', featureFlags: { __typename?: 'FeatureFlags', enabled: Array<string> } };

export const AudioMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AudioMatchFieldsFragment, unknown>;
export const ImageMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<ImageMatchFieldsFragment, unknown>;
export const TextMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<TextMatchFieldsFragment, unknown>;
export const TranscriptMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}}]} as unknown as DocumentNode<TranscriptMatchFieldsFragment, unknown>;
export const VideoMatchFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"segmentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<VideoMatchFieldsFragment, unknown>;
export const MatchBreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"segmentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}}]} as unknown as DocumentNode<MatchBreakdownFragment, unknown>;
export const CheckerDetectionResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckerDetectionResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DnaDetectionResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringementMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"incompleteReason"}},{"kind":"Field","name":{"kind":"Name","value":"windowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"capturedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"processedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"baseFingerprintProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"algorithm"}},{"kind":"Field","name":{"kind":"Name","value":"modality"}},{"kind":"Field","name":{"kind":"Name","value":"scorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoreKind"}},{"kind":"Field","name":{"kind":"Name","value":"validationPending"}},{"kind":"Field","name":{"kind":"Name","value":"riskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"strict"}},{"kind":"Field","name":{"kind":"Name","value":"audioCompositionEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policyScore"}},{"kind":"Field","name":{"kind":"Name","value":"policyMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rawScore"}},{"kind":"Field","name":{"kind":"Name","value":"referenceStartSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"supporting"}},{"kind":"Field","name":{"kind":"Name","value":"supportKind"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"exactLaneMatch"}},{"kind":"Field","name":{"kind":"Name","value":"arm"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"modelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"policyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"metadataStatus"}}]}}]}}]} as unknown as DocumentNode<CheckerDetectionResultFragment, unknown>;
export const OriginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Origins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"white"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"black"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OriginsQuery, OriginsQueryVariables>;
export const VerifyIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyIdentity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyIdentityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyIdentity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]} as unknown as DocumentNode<VerifyIdentityMutation, VerifyIdentityMutationVariables>;
export const CopyrightFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CopyrightFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sheetMusic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sheetMusic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNotificationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CopyrightFileQuery, CopyrightFileQueryVariables>;
export const FolderByPathDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FolderByPath"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemSort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"registrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}}]} as unknown as DocumentNode<FolderByPathQuery, FolderByPathQueryVariables>;
export const SetMatchVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMatchVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetMatchVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setMatchVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SetMatchVisibilityMutation, SetMatchVisibilityMutationVariables>;
export const MatchCategoryBreakdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchCategoryBreakdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchBreakdown"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"segmentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}}]} as unknown as DocumentNode<MatchCategoryBreakdownQuery, MatchCategoryBreakdownQueryVariables>;
export const InfringementListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfringementList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InfringementsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalFlags"}},{"kind":"Field","name":{"kind":"Name","value":"totalReports"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"copyrights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"audioBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedWorks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"matchSources"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InfringementListQuery, InfringementListQueryVariables>;
export const ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"audioBundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regularStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueComplete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueComplete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"noMatch"}},{"kind":"Field","name":{"kind":"Name","value":"searchedScopeComplete"}},{"kind":"Field","name":{"kind":"Name","value":"catalogueComplete"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedWorksComplete"}},{"kind":"Field","name":{"kind":"Name","value":"totalWindows"}},{"kind":"Field","name":{"kind":"Name","value":"processedWindows"}},{"kind":"Field","name":{"kind":"Name","value":"unprocessedWindows"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedWorks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"accepted"}},{"kind":"Field","name":{"kind":"Name","value":"matchSources"}},{"kind":"Field","name":{"kind":"Name","value":"coverWitnessesComplete"}},{"kind":"Field","name":{"kind":"Name","value":"regular"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashType"}},{"kind":"Field","name":{"kind":"Name","value":"similarityScore"}},{"kind":"Field","name":{"kind":"Name","value":"scoreKind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverWitnesses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"windowIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startMs"}},{"kind":"Field","name":{"kind":"Name","value":"spanMs"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"gate"}},{"kind":"Field","name":{"kind":"Name","value":"topTied"}},{"kind":"Field","name":{"kind":"Name","value":"admitted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MatchBreakdown"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AudioMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"matchingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amplitudeUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TextMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x1"}},{"kind":"Field","name":{"kind":"Name","value":"x2"}},{"kind":"Field","name":{"kind":"Name","value":"y1"}},{"kind":"Field","name":{"kind":"Name","value":"y2"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoMatchFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"frames"}},{"kind":"Field","name":{"kind":"Name","value":"segmentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MatchBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MatchCategoryBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"shine"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfringingFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AudioMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TextMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptMatchFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoMatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoMatchFields"}}]}}]}}]}}]} as unknown as DocumentNode<ReportQuery, ReportQueryVariables>;
export const CreateFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackId"}}]}}]}}]} as unknown as DocumentNode<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const RemoveFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveFeedbackMutation, RemoveFeedbackMutationVariables>;
export const FileViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileViewersQuery, FileViewersQueryVariables>;
export const AddViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddViewersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addViewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddViewersMutation, AddViewersMutationVariables>;
export const UpdateViewerPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateViewerPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateViewerPermissionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateViewerPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateViewerPermissionsMutation, UpdateViewerPermissionsMutationVariables>;
export const FileAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileAuthors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileAuthorsQuery, FileAuthorsQueryVariables>;
export const AddAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddAuthors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddAuthorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addAuthors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddAuthorsMutation, AddAuthorsMutationVariables>;
export const FileOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FileOwnersQuery, FileOwnersQueryVariables>;
export const AddCoOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCoOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCoOwnersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCoOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coOwners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntityWithRole"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCoOwnersMutation, AddCoOwnersMutationVariables>;
export const MoveFoldersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MoveFolders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderByPath"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"FOLDER"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Folder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiles"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MoveFoldersQuery, MoveFoldersQueryVariables>;
export const RemoveViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveViewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeViewer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveViewerMutation, RemoveViewerMutationVariables>;
export const RemoveAuthorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveAuthor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveAuthorInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAuthor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveAuthorMutation, RemoveAuthorMutationVariables>;
export const RemoveCoOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCoOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCoOwnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCoOwner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveCoOwnerMutation, RemoveCoOwnerMutationVariables>;
export const StartDnaCaptureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartDnaCapture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DnaCaptureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDnaCapture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"batchSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"minAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"windowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"maxAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"maxBatchBytes"}}]}}]}}]} as unknown as DocumentNode<StartDnaCaptureMutation, StartDnaCaptureMutationVariables>;
export const DetectDnaCaptureBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DetectDnaCaptureBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DnaCaptureBatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detectDnaCaptureBatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckerDetectionResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckerDetectionResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DnaDetectionResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringementMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"incompleteReason"}},{"kind":"Field","name":{"kind":"Name","value":"windowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"capturedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"processedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"baseFingerprintProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"algorithm"}},{"kind":"Field","name":{"kind":"Name","value":"modality"}},{"kind":"Field","name":{"kind":"Name","value":"scorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoreKind"}},{"kind":"Field","name":{"kind":"Name","value":"validationPending"}},{"kind":"Field","name":{"kind":"Name","value":"riskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"strict"}},{"kind":"Field","name":{"kind":"Name","value":"audioCompositionEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policyScore"}},{"kind":"Field","name":{"kind":"Name","value":"policyMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rawScore"}},{"kind":"Field","name":{"kind":"Name","value":"referenceStartSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"supporting"}},{"kind":"Field","name":{"kind":"Name","value":"supportKind"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"exactLaneMatch"}},{"kind":"Field","name":{"kind":"Name","value":"arm"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"modelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"policyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"metadataStatus"}}]}}]}}]} as unknown as DocumentNode<DetectDnaCaptureBatchMutation, DetectDnaCaptureBatchMutationVariables>;
export const StopDnaCaptureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StopDnaCapture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopDnaCapture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckerDetectionResult"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckerDetectionResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DnaDetectionResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringementMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"incompleteReason"}},{"kind":"Field","name":{"kind":"Name","value":"windowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"capturedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"processedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"baseFingerprintProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"algorithm"}},{"kind":"Field","name":{"kind":"Name","value":"modality"}},{"kind":"Field","name":{"kind":"Name","value":"scorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoreKind"}},{"kind":"Field","name":{"kind":"Name","value":"validationPending"}},{"kind":"Field","name":{"kind":"Name","value":"riskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"strict"}},{"kind":"Field","name":{"kind":"Name","value":"audioCompositionEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policyScore"}},{"kind":"Field","name":{"kind":"Name","value":"policyMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rawScore"}},{"kind":"Field","name":{"kind":"Name","value":"referenceStartSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"supporting"}},{"kind":"Field","name":{"kind":"Name","value":"supportKind"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"exactLaneMatch"}},{"kind":"Field","name":{"kind":"Name","value":"arm"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"modelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"policyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"metadataStatus"}}]}}]}}]} as unknown as DocumentNode<StopDnaCaptureMutation, StopDnaCaptureMutationVariables>;
export const CreateDnaDetectionMultipartUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDnaDetectionMultipartUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DnaDetectionMultipartUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDnaDetectionMultipartUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"maxBytes"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"partSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"partCount"}},{"kind":"Field","name":{"kind":"Name","value":"parts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDnaDetectionMultipartUploadMutation, CreateDnaDetectionMultipartUploadMutationVariables>;
export const SignDnaDetectionUploadPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignDnaDetectionUploadParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DnaSignDetectionUploadPartsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signDnaDetectionUploadParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SignDnaDetectionUploadPartsMutation, SignDnaDetectionUploadPartsMutationVariables>;
export const StartDnaFileDetectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartDnaFileDetection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDnaFileDetection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<StartDnaFileDetectionMutation, StartDnaFileDetectionMutationVariables>;
export const CancelDnaFileDetectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelDnaFileDetection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelDnaFileDetection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CancelDnaFileDetectionMutation, CancelDnaFileDetectionMutationVariables>;
export const DnaFileDetectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DnaFileDetection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dnaFileDetection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalBytes"}},{"kind":"Field","name":{"kind":"Name","value":"transferredBytes"}},{"kind":"Field","name":{"kind":"Name","value":"windowsDone"}},{"kind":"Field","name":{"kind":"Name","value":"windowsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CheckerDetectionResult"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"retryable"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CheckerDetectionResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DnaDetectionResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringementMatchIds"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"completeCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"incompleteReason"}},{"kind":"Field","name":{"kind":"Name","value":"windowSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"capturedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"processedAudioSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"baseFingerprintProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDataId"}},{"kind":"Field","name":{"kind":"Name","value":"registrationId"}},{"kind":"Field","name":{"kind":"Name","value":"algorithm"}},{"kind":"Field","name":{"kind":"Name","value":"modality"}},{"kind":"Field","name":{"kind":"Name","value":"scorePercent"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"scoreKind"}},{"kind":"Field","name":{"kind":"Name","value":"validationPending"}},{"kind":"Field","name":{"kind":"Name","value":"riskLevel"}},{"kind":"Field","name":{"kind":"Name","value":"strict"}},{"kind":"Field","name":{"kind":"Name","value":"audioCompositionEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policyScore"}},{"kind":"Field","name":{"kind":"Name","value":"policyMargin"}},{"kind":"Field","name":{"kind":"Name","value":"rawScore"}},{"kind":"Field","name":{"kind":"Name","value":"referenceStartSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"supporting"}},{"kind":"Field","name":{"kind":"Name","value":"supportKind"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"exactLaneMatch"}},{"kind":"Field","name":{"kind":"Name","value":"arm"}},{"kind":"Field","name":{"kind":"Name","value":"rule"}},{"kind":"Field","name":{"kind":"Name","value":"modelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"policyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"metadataStatus"}}]}}]}}]} as unknown as DocumentNode<DnaFileDetectionQuery, DnaFileDetectionQueryVariables>;
export const AddReportViewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddReportViewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddReportViewersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReportViewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmailInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddReportViewersMutation, AddReportViewersMutationVariables>;
export const RemoveReportViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveReportViewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveReportViewerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeReportViewer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveReportViewerMutation, RemoveReportViewerMutationVariables>;
export const UpdateReportSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateReportSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateReportSettingsMutation, UpdateReportSettingsMutationVariables>;
export const InfringingFileDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfringingFileDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infringement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"infringingFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightId"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StreamAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streamUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceLabel"}},{"kind":"Field","name":{"kind":"Name","value":"captureType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recognizedOrigins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCopyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recognizedOrigins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InfringingFileDetailsQuery, InfringingFileDetailsQueryVariables>;
export const InfringingRegistrationFallbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InfringingRegistrationFallback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AudioAnalysis"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InfringingRegistrationFallbackQuery, InfringingRegistrationFallbackQueryVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const ReportProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"callout"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]} as unknown as DocumentNode<ReportProductsQuery, ReportProductsQueryVariables>;
export const UploadInfringingFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadInfringingFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadInfringingFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadInfringingFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"headers"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UploadInfringingFileMutation, UploadInfringingFileMutationVariables>;
export const PurchaseReportCreditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurchaseReportCredits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseReportCreditsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseReportCredits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseReportCreditsMutation, PurchaseReportCreditsMutationVariables>;
export const EstimateRegistrationCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateRegistrationCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateRegistrationCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateRegistrationCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimateRegistrationCostQuery, EstimateRegistrationCostQueryVariables>;
export const FeatureFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureFlags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<FeatureFlagsQuery, FeatureFlagsQueryVariables>;